/* WARNING: This file is auto-generated . Do not edit manually. */

import { TelephonyFax } from '../models/TelephonyFax';
import { TelephonyFaxConsumptionWayTypeEnum } from '../models/TelephonyFaxConsumptionWayTypeEnum';
import { TelephonyVoicefaxRoutingEnum } from '../models/TelephonyVoicefaxRoutingEnum';
import { TelephonyOvhPabxRecord } from '../models/TelephonyOvhPabxRecord';
import { TelephonyTemporaryLogsLink } from '../models/TelephonyTemporaryLogsLink';
import { TelephonyAbbreviatedNumber } from '../models/TelephonyAbbreviatedNumber';
import { TelephonyOvhPabxDialplanExtensionConditionTime } from '../models/TelephonyOvhPabxDialplanExtensionConditionTime';
import { TelephonyAccessoryOffer } from '../models/TelephonyAccessoryOffer';
import { TelephonyOvhPabxWhisperingModeEnum } from '../models/TelephonyOvhPabxWhisperingModeEnum';
import { TelephonyRedirect } from '../models/TelephonyRedirect';
import { TelephonyHistoryTollfreeConsumption } from '../models/TelephonyHistoryTollfreeConsumption';
import { TelephonyFaxProperties } from '../models/TelephonyFaxProperties';
import { TelephonyEasyPabx } from '../models/TelephonyEasyPabx';
import { TelephonyVoicemailMessageFolderGreetingEnum } from '../models/TelephonyVoicemailMessageFolderGreetingEnum';
import { TelephonyBillDocument } from '../models/TelephonyBillDocument';
import { TelephonyTimestampAndValue } from '../models/TelephonyTimestampAndValue';
import { TelephonyEasyHuntingTimeConditions } from '../models/TelephonyEasyHuntingTimeConditions';
import { TelephonyFaxCampaign } from '../models/TelephonyFaxCampaign';
import { TelephonyLineStatisticsTypeEnum } from '../models/TelephonyLineStatisticsTypeEnum';
import { TelephonyVoiceConsumptionPlanTypeEnum } from '../models/TelephonyVoiceConsumptionPlanTypeEnum';
import { TelephonyPhonebookMaster } from '../models/TelephonyPhonebookMaster';
import { TelephonyOvhPabxHuntingAgentQueue } from '../models/TelephonyOvhPabxHuntingAgentQueue';
import { TelephonyDefaultSipDomains } from '../models/TelephonyDefaultSipDomains';
import { TelephonyHistoryConsumption } from '../models/TelephonyHistoryConsumption';
import { TelephonyOvhPabxHuntingQueueRecordDisablingLanguageEnum } from '../models/TelephonyOvhPabxHuntingQueueRecordDisablingLanguageEnum';
import { OrderPrice } from '../models/OrderPrice';
import { TelephonyFaxScreenListTypeEnum } from '../models/TelephonyFaxScreenListTypeEnum';
import { TelephonyVoiceConsumptionDestinationTypeEnum } from '../models/TelephonyVoiceConsumptionDestinationTypeEnum';
import { TelephonyAbbreviatedNumberGroup } from '../models/TelephonyAbbreviatedNumberGroup';
import { TelephonyOvhPabxMenuEntry } from '../models/TelephonyOvhPabxMenuEntry';
import { TelephonyVoicemailNumbers } from '../models/TelephonyVoicemailNumbers';
import { TelephonySimultaneousChannelsDetails } from '../models/TelephonySimultaneousChannelsDetails';
import { TelephonySpecificNumber } from '../models/TelephonySpecificNumber';
import { TelephonyDirectoryWayType } from '../models/TelephonyDirectoryWayType';
import { TelephonyTrafficExtract } from '../models/TelephonyTrafficExtract';
import { TelephonyEasyHunting } from '../models/TelephonyEasyHunting';
import { TelephonyOvhPabxQueueActionEnum } from '../models/TelephonyOvhPabxQueueActionEnum';
import { TelephonyOvhPabxDialplan } from '../models/TelephonyOvhPabxDialplan';
import { TelephonyProcedure } from '../models/TelephonyProcedure';
import { TelephonyPreviousVoiceConsumption } from '../models/TelephonyPreviousVoiceConsumption';
import { TelephonyVoicemailMessages } from '../models/TelephonyVoicemailMessages';
import { TelephonyHardwareOffer } from '../models/TelephonyHardwareOffer';
import { TelephonyTelephonyService } from '../models/TelephonyTelephonyService';
import { TelephonyBillingAccount } from '../models/TelephonyBillingAccount';
import { TelephonyTimeConditionsDayEnum } from '../models/TelephonyTimeConditionsDayEnum';
import { TelephonyOvhPabxDialplanNumberPresentationEnum } from '../models/TelephonyOvhPabxDialplanNumberPresentationEnum';
import { TelephonyConferenceParticipants } from '../models/TelephonyConferenceParticipants';
import { TelephonyCarrierSipClusterInfo } from '../models/TelephonyCarrierSipClusterInfo';
import { TelephonyOvhPabxHuntingQueueStrategyEnum } from '../models/TelephonyOvhPabxHuntingQueueStrategyEnum';
import { TelephonyTrunkSimultaneousPacksRepartition } from '../models/TelephonyTrunkSimultaneousPacksRepartition';
import { TelephonyRateCodeInformation } from '../models/TelephonyRateCodeInformation';
import { TelephonyNumberTypeEnum } from '../models/TelephonyNumberTypeEnum';
import { TelephonyLineOptions } from '../models/TelephonyLineOptions';
import { TelephonyVoiceConsumption } from '../models/TelephonyVoiceConsumption';
import { TelephonyVxmlProperties } from '../models/TelephonyVxmlProperties';
import { TelephonyClick2CallUser } from '../models/TelephonyClick2CallUser';
import { TelephonyVxml } from '../models/TelephonyVxml';
import { TelephonyOutplanNotificationBlockEnum } from '../models/TelephonyOutplanNotificationBlockEnum';
import { TelephonyServiceNumberCountryEnum } from '../models/TelephonyServiceNumberCountryEnum';
import { TelephonyRmaPublicTypeEnum } from '../models/TelephonyRmaPublicTypeEnum';
import { TelephonyCallsGenerated } from '../models/TelephonyCallsGenerated';
import { TelephonyDirectoryHeadingPJ } from '../models/TelephonyDirectoryHeadingPJ';
import { TelephonySchedulerEvent } from '../models/TelephonySchedulerEvent';
import { TelephonyVoiceConsumptionWayTypeEnum } from '../models/TelephonyVoiceConsumptionWayTypeEnum';
import { TelephonyRmaChangeTypeEnum } from '../models/TelephonyRmaChangeTypeEnum';
import { TelephonyConferenceRoomsStatistics } from '../models/TelephonyConferenceRoomsStatistics';
import { TelephonyNumberDetailedZone } from '../models/TelephonyNumberDetailedZone';
import { TelephonyConference } from '../models/TelephonyConference';
import { TelephonyOvhPabxDialplanExtensionRuleActionEnum } from '../models/TelephonyOvhPabxDialplanExtensionRuleActionEnum';
import { TelephonyFaxCampaignSendTypeEnum } from '../models/TelephonyFaxCampaignSendTypeEnum';
import { TelephonyCarrierSip } from '../models/TelephonyCarrierSip';
import { TelephonyMiniPabxHunting } from '../models/TelephonyMiniPabxHunting';
import { TelephonySchedulerCategoryEnum } from '../models/TelephonySchedulerCategoryEnum';
import { TelephonyVoicemailGreetings } from '../models/TelephonyVoicemailGreetings';
import { TelephonyTelephonyGenericService } from '../models/TelephonyTelephonyGenericService';
import { TelephonyCarrierSipCustomerEndpoint } from '../models/TelephonyCarrierSipCustomerEndpoint';
import { TelephonyConferenceRoom } from '../models/TelephonyConferenceRoom';
import { TelephonyOvhPabxDialplanExtension } from '../models/TelephonyOvhPabxDialplanExtension';
import { TelephonyRepaymentConsumption } from '../models/TelephonyRepaymentConsumption';
import { TelephonyTimeConditionOptions } from '../models/TelephonyTimeConditionOptions';
import { TelephonyOvhPabxTts } from '../models/TelephonyOvhPabxTts';
import { TelephonySipDomainProductTypeEnum } from '../models/TelephonySipDomainProductTypeEnum';
import { TelephonyOfferTask } from '../models/TelephonyOfferTask';
import { TelephonyOvhPabxHuntingQueue } from '../models/TelephonyOvhPabxHuntingQueue';
import { TelephonyEasyMiniPabxHuntingAgent } from '../models/TelephonyEasyMiniPabxHuntingAgent';
import { TelephonyOldPhone } from '../models/TelephonyOldPhone';
import { TelephonyConferenceWebAccessTypeEnum } from '../models/TelephonyConferenceWebAccessTypeEnum';
import { TelephonyDatetimeAndIpvalue } from '../models/TelephonyDatetimeAndIpvalue';
import { TelephonyLinePhoneAssociable } from '../models/TelephonyLinePhoneAssociable';
import { TelephonyOfferChange } from '../models/TelephonyOfferChange';
import { TelephonyOvhPabxHunting } from '../models/TelephonyOvhPabxHunting';
import { TelephonyLinePhone } from '../models/TelephonyLinePhone';
import { TelephonyDiagnosticReport } from '../models/TelephonyDiagnosticReport';
import { TelephonyLineBlockingMode } from '../models/TelephonyLineBlockingMode';
import { TelephonyVoicemailProperties } from '../models/TelephonyVoicemailProperties';
import { TelephonyOvhPabxDialplanExtensionConditionScreenListTypeEnum } from '../models/TelephonyOvhPabxDialplanExtensionConditionScreenListTypeEnum';
import { TelephonyTask } from '../models/TelephonyTask';
import { TelephonyTrunk } from '../models/TelephonyTrunk';
import { TelephonyAntihackActionEnum } from '../models/TelephonyAntihackActionEnum';
import { TelephonyDocument } from '../models/TelephonyDocument';
import { TelephonyLineOffer } from '../models/TelephonyLineOffer';
import { TelephonyConferenceWebAccess } from '../models/TelephonyConferenceWebAccess';
import { TelephonyTaskStatusEnum } from '../models/TelephonyTaskStatusEnum';
import { ServicesService } from '../models/ServicesService';
import { TelephonyOvhPabxDialplanExtensionRule } from '../models/TelephonyOvhPabxDialplanExtensionRule';
import { TelephonyRsva } from '../models/TelephonyRsva';
import { TelephonyRma } from '../models/TelephonyRma';
import { TelephonyOvhPabxIvrMenuEntryActionEnum } from '../models/TelephonyOvhPabxIvrMenuEntryActionEnum';
import { TelephonyScreenListNatureEnum } from '../models/TelephonyScreenListNatureEnum';
import { TelephonyVoicemailMessageFolderDirectoryEnum } from '../models/TelephonyVoicemailMessageFolderDirectoryEnum';
import { TelephonyTimeConditionsPolicyEnum } from '../models/TelephonyTimeConditionsPolicyEnum';
import { TelephonyBannerAccess } from '../models/TelephonyBannerAccess';
import { TelephonyPcsFile } from '../models/TelephonyPcsFile';
import { TelephonyDetailedRateCodeInformation } from '../models/TelephonyDetailedRateCodeInformation';
import { TelephonyPhoneCredentials } from '../models/TelephonyPhoneCredentials';
import { TelephonyServiceVoicemailAudioFormatEnum } from '../models/TelephonyServiceVoicemailAudioFormatEnum';
import { TelephonyHistoryRepaymentConsumption } from '../models/TelephonyHistoryRepaymentConsumption';
import { TelephonyMiniPabx } from '../models/TelephonyMiniPabx';
import { TelephonyTokenExpirationEnum } from '../models/TelephonyTokenExpirationEnum';
import { TelephonyOvhPabxSound } from '../models/TelephonyOvhPabxSound';
import { TelephonyOvhPabxHuntingQueueLiveStatistics } from '../models/TelephonyOvhPabxHuntingQueueLiveStatistics';
import { TelephonyCarrierSipDetails } from '../models/TelephonyCarrierSipDetails';
import { TelephonyOvhPabxDialplanExtensionConditionScreenList } from '../models/TelephonyOvhPabxDialplanExtensionConditionScreenList';
import { TelephonyPhonebookContact } from '../models/TelephonyPhonebookContact';
import { TelephonyDirectoryInfo } from '../models/TelephonyDirectoryInfo';
import { TelephonyTrunkExternalDisplayedNumberValidation } from '../models/TelephonyTrunkExternalDisplayedNumberValidation';
import { TelephonyOvhPabxCustomStatus } from '../models/TelephonyOvhPabxCustomStatus';
import { TelephonyScreen } from '../models/TelephonyScreen';
import { TelephonyOvhPabxHuntingQueueLiveCalls } from '../models/TelephonyOvhPabxHuntingQueueLiveCalls';
import { TelephonyNumber } from '../models/TelephonyNumber';
import { TelephonyScheduler } from '../models/TelephonyScheduler';
import { TelephonyNumberCountryEnum } from '../models/TelephonyNumberCountryEnum';
import { TelephonyEasyPabxHunting } from '../models/TelephonyEasyPabxHunting';
import { TelephonyOfferTaskTypeEnum } from '../models/TelephonyOfferTaskTypeEnum';
import { TelephonyGenericScreen } from '../models/TelephonyGenericScreen';
import { TelephonyCity } from '../models/TelephonyCity';
import { TelephonyConferenceHistory } from '../models/TelephonyConferenceHistory';
import { TelephonyOvhPabxHuntingAgentLiveStatus } from '../models/TelephonyOvhPabxHuntingAgentLiveStatus';
import { TelephonyLine } from '../models/TelephonyLine';
import { TelephonyOvhPabxHuntingQueueRecordDisablingDigitEnum } from '../models/TelephonyOvhPabxHuntingQueueRecordDisablingDigitEnum';
import { TelephonyPortability } from '../models/TelephonyPortability';
import { TelephonyLineOffersAndContracts } from '../models/TelephonyLineOffersAndContracts';
import { TelephonyScreenListTypeEnum } from '../models/TelephonyScreenListTypeEnum';
import { TelephonyConferenceInformations } from '../models/TelephonyConferenceInformations';
import { TelephonyEasyHuntingScreenListsConditionsSettings } from '../models/TelephonyEasyHuntingScreenListsConditionsSettings';
import { TelephonyOvhPabxMenu } from '../models/TelephonyOvhPabxMenu';
import { TelephonyStatisticsTimeframeEnum } from '../models/TelephonyStatisticsTimeframeEnum';
import { TelephonyOvhPabxHuntingAgentStatusEnum } from '../models/TelephonyOvhPabxHuntingAgentStatusEnum';
import { TelephonySound } from '../models/TelephonySound';
import { TelephonyRegistrationInformations } from '../models/TelephonyRegistrationInformations';
import { TelephonyConsumptionThreshold } from '../models/TelephonyConsumptionThreshold';
import { SpareTelephonyTelephonySpare } from '../models/SpareTelephonyTelephonySpare';
import { TelephonyFaxCampaignRecipientsTypeEnum } from '../models/TelephonyFaxCampaignRecipientsTypeEnum';
import { TelephonyResetPhoneInfo } from '../models/TelephonyResetPhoneInfo';
import { TelephonyTrunkExternalDisplayedNumber } from '../models/TelephonyTrunkExternalDisplayedNumber';
import { TelephonyTones } from '../models/TelephonyTones';
import { TelephonyTypeEnum } from '../models/TelephonyTypeEnum';
import { TelephonyEntrepriseNumberInformationsTask } from '../models/TelephonyEntrepriseNumberInformationsTask';
import { TelephonyFaxConsumption } from '../models/TelephonyFaxConsumption';
import { TelephonyTimeCondition } from '../models/TelephonyTimeCondition';
import { TelephonyPortabilityDocument } from '../models/TelephonyPortabilityDocument';
import { TelephonyOvhPabxHuntingAgent } from '../models/TelephonyOvhPabxHuntingAgent';
import { TelephonyFaxQualityEnum } from '../models/TelephonyFaxQualityEnum';
import { TelephonyCallsGeneratorDialplanEnum } from '../models/TelephonyCallsGeneratorDialplanEnum';
import { TelephonyConferenceProperties } from '../models/TelephonyConferenceProperties';
import { TelephonyScreenList } from '../models/TelephonyScreenList';
import { TelephonyDiagnosticReportIndexEnum } from '../models/TelephonyDiagnosticReportIndexEnum';
import { TelephonyContactsExportFormatsEnum } from '../models/TelephonyContactsExportFormatsEnum';
import { TelephonyPhonebook } from '../models/TelephonyPhonebook';
import { TelephonyCallDiagnostics } from '../models/TelephonyCallDiagnostics';
import { TelephonyDdi } from '../models/TelephonyDdi';
import { TelephonyOfferTaskActionEnum } from '../models/TelephonyOfferTaskActionEnum';
import { TelephonyEasyHuntingScreenListsConditions } from '../models/TelephonyEasyHuntingScreenListsConditions';
import { TelephonyFaxScreen } from '../models/TelephonyFaxScreen';
import { TelephonyRmaReturn } from '../models/TelephonyRmaReturn';
import { TelephonyTonesTypeEnum } from '../models/TelephonyTonesTypeEnum';
import { TelephonyOvhPabxDialplanExtensionConditionTimeWeekDayEnum } from '../models/TelephonyOvhPabxDialplanExtensionConditionTimeWeekDayEnum';
import { TelephonyOvhPabx } from '../models/TelephonyOvhPabx';
import { TelephonyTerminationReasonEnum } from '../models/TelephonyTerminationReasonEnum';
import { TelephonyPhone } from '../models/TelephonyPhone';
import { TelephonyTelephonySearchService } from '../models/TelephonyTelephonySearchService';
import { TelephonyFaxCampaignDetail } from '../models/TelephonyFaxCampaignDetail';
import { TelephonyFunctionKey } from '../models/TelephonyFunctionKey';
import { TelephonyVoicemail } from '../models/TelephonyVoicemail';
import { TelephonyPortabilityFixErrorPossibleParameters } from '../models/TelephonyPortabilityFixErrorPossibleParameters';
import { TelephonyResellerPanelStatus } from '../models/TelephonyResellerPanelStatus';
import { TelephonyPortabilityStep } from '../models/TelephonyPortabilityStep';
import { TelephonyEventToken } from '../models/TelephonyEventToken';
import { TelephonyEasyHuntingTimeConditionsSettings } from '../models/TelephonyEasyHuntingTimeConditionsSettings';
import { TelephonyOvhPabxTtsVoiceEnum } from '../models/TelephonyOvhPabxTtsVoiceEnum';
import OVHBase from '../ovh';

class TelephonyHandler {
  ovh: OVHBase;

  constructor(ovh: OVHBase) {
    this.ovh = ovh;
  }

  /** List available services */
  list = (): Promise<string[]> => {
    return this.ovh.request('GET', '/telephony');
  };

  /** Get all available accessories */
  getAccessories = (): Promise<TelephonyAccessoryOffer[]> => {
    return this.ovh.request('GET', '/telephony/accessories');
  };

  /** List available services */
  listAliases = (): Promise<string[]> => {
    return this.ovh.request('GET', '/telephony/aliases');
  };

  /** Get this object properties */
  getAliasesByServiceName = (serviceName: string): Promise<TelephonyTelephonyGenericService> => {
    return this.ovh.request('GET', `/telephony/aliases/${serviceName}`);
  };

  /** Launch a contact change procedure */
  launchAliasesChangeContactByServiceName = (
    serviceName: string,
    body: { contactAdmin?: string; contactBilling?: string; contactTech?: string }
  ): Promise<number[]> => {
    return this.ovh.request('POST', `/telephony/aliases/${serviceName}/changeContact`, body);
  };

  /** Get this object properties */
  getAliasesServiceInfosByServiceName = (serviceName: string): Promise<ServicesService> => {
    return this.ovh.request('GET', `/telephony/aliases/${serviceName}/serviceInfos`);
  };

  /** Alter this object properties */
  updateAliasesServiceInfosByServiceName = (
    serviceName: string,
    body: ServicesService
  ): Promise<void> => {
    return this.ovh.request('PUT', `/telephony/aliases/${serviceName}/serviceInfos`, body);
  };

  /** Get all available SIP domains by country */
  getAvailableDefaultSipDomains = (): Promise<TelephonyDefaultSipDomains[]> => {
    return this.ovh.request('GET', '/telephony/availableDefaultSipDomains');
  };

  /** Get current order ids */
  getCurrentOrderIds = (): Promise<number[]> => {
    return this.ovh.request('GET', '/telephony/currentOrderIds');
  };

  /** Get all zip codes compatible for a number */
  getDirectoriesAvailableZipCodes = (): Promise<string[]> => {
    return this.ovh.request('GET', '/telephony/directories/availableZipCodes');
  };

  /** Get city informations from a zip code */
  getDirectoriesCities = (): Promise<TelephonyCity[]> => {
    return this.ovh.request('GET', '/telephony/directories/cities');
  };

  /** Get all available fax offer compatible */
  getFaxOffers = (): Promise<TelephonyLineOffer[]> => {
    return this.ovh.request('GET', '/telephony/fax/offers');
  };

  /** Get all available phone brands compatible with lines */
  getLineOfferPhones = (): Promise<TelephonyLinePhone[]> => {
    return this.ovh.request('GET', '/telephony/line/offer/phones');
  };

  /** Get all available line offer compatible */
  getLineOffers = (): Promise<TelephonyLineOffer[]> => {
    return this.ovh.request('GET', '/telephony/line/offers');
  };

  /** List available services */
  listLines = (): Promise<string[]> => {
    return this.ovh.request('GET', '/telephony/lines');
  };

  /** Get this object properties */
  getLinesByServiceName = (serviceName: string): Promise<TelephonyTelephonyGenericService> => {
    return this.ovh.request('GET', `/telephony/lines/${serviceName}`);
  };

  /** Launch a contact change procedure */
  launchLinesChangeContactByServiceName = (
    serviceName: string,
    body: { contactAdmin?: string; contactBilling?: string; contactTech?: string }
  ): Promise<number[]> => {
    return this.ovh.request('POST', `/telephony/lines/${serviceName}/changeContact`, body);
  };

  /** Get this object properties */
  getLinesServiceInfosByServiceName = (serviceName: string): Promise<ServicesService> => {
    return this.ovh.request('GET', `/telephony/lines/${serviceName}/serviceInfos`);
  };

  /** Alter this object properties */
  updateLinesServiceInfosByServiceName = (
    serviceName: string,
    body: ServicesService
  ): Promise<void> => {
    return this.ovh.request('PUT', `/telephony/lines/${serviceName}/serviceInfos`, body);
  };

  /** Get all available geographic zone with some details, from a country */
  getNumberDetailedZones = (): Promise<TelephonyNumberDetailedZone[]> => {
    return this.ovh.request('GET', '/telephony/number/detailedZones');
  };

  /** Get all available special range from a country */
  getNumberRanges = (): Promise<string[]> => {
    return this.ovh.request('GET', '/telephony/number/ranges');
  };

  /** Get all available specific number from a country */
  getNumberSpecificNumbers = (): Promise<TelephonySpecificNumber[]> => {
    return this.ovh.request('GET', '/telephony/number/specificNumbers');
  };

  /** Get all available geographic zone from a country */
  getNumberZones = (): Promise<string[]> => {
    return this.ovh.request('GET', '/telephony/number/zones');
  };

  /** Procedures linked to your nichandle */
  getProcedure = (): Promise<number[]> => {
    return this.ovh.request('GET', '/telephony/procedure');
  };

  /** Create a telephony procedure */
  createProcedure = (body: {
    bic?: string;
    iban?: string;
    ownerAddress?: string;
    ownerName?: string;
    paymentMeanID?: number;
  }): Promise<TelephonyProcedure> => {
    return this.ovh.request('POST', '/telephony/procedure', body);
  };

  /** Tells whether the procedure is necessary to order telephony products or not */
  getProcedureRequired = (): Promise<boolean> => {
    return this.ovh.request('GET', '/telephony/procedure/required');
  };

  /** Get this object properties */
  getProcedureById = (id: number): Promise<TelephonyProcedure> => {
    return this.ovh.request('GET', `/telephony/procedure/${id}`);
  };

  /** Cancel the given procedure. */
  postProcedureCancelById = (id: number): Promise<void> => {
    return this.ovh.request('POST', `/telephony/procedure/${id}/cancel`);
  };

  /** Generate a new password for the reseller panel */
  postResellerPanelGeneratePassword = (): Promise<void> => {
    return this.ovh.request('POST', '/telephony/resellerPanel/generatePassword');
  };

  /** Status of customer reseller panel */
  getResellerPanelStatus = (): Promise<TelephonyResellerPanelStatus> => {
    return this.ovh.request('GET', '/telephony/resellerPanel/status');
  };

  /** Search a service with its domain, to get its billing account and type */
  getSearchServices = (): Promise<TelephonyTelephonySearchService[]> => {
    return this.ovh.request('GET', '/telephony/searchServices');
  };

  /** Get all available SIP domains by country */
  postSetDefaultSipDomain = (body: {
    country: TelephonyServiceNumberCountryEnum;
    domain: string;
    type: TelephonySipDomainProductTypeEnum;
  }): Promise<void> => {
    return this.ovh.request('POST', '/telephony/setDefaultSipDomain', body);
  };

  /** Sounds attached to this telephony account */
  getSounds = (): Promise<number[]> => {
    return this.ovh.request('GET', '/telephony/sounds');
  };

  /** Create a new sound */
  createSounds = (body: { description?: string; filename: string }): Promise<TelephonySound> => {
    return this.ovh.request('POST', '/telephony/sounds', body);
  };

  /** Delete the sound */
  deleteSoundsById = (id: number): Promise<void> => {
    return this.ovh.request('DELETE', `/telephony/sounds/${id}`);
  };

  /** Get this object properties */
  getSoundsById = (id: number): Promise<TelephonySound> => {
    return this.ovh.request('GET', `/telephony/sounds/${id}`);
  };

  /** Alter this object properties */
  updateSoundsById = (id: number, body: TelephonySound): Promise<void> => {
    return this.ovh.request('PUT', `/telephony/sounds/${id}`, body);
  };

  /** List available services */
  listSpare = (): Promise<string[]> => {
    return this.ovh.request('GET', '/telephony/spare');
  };

  /** Get all available spare brands */
  getSpareBrands = (): Promise<string[]> => {
    return this.ovh.request('GET', '/telephony/spare/brands');
  };

  /** Delete the spare as if it was not belonging to OVH anymore */
  deleteSpareBySpare = (spare: string): Promise<void> => {
    return this.ovh.request('DELETE', `/telephony/spare/${spare}`);
  };

  /** Get this object properties */
  getSpareBySpare = (spare: string): Promise<SpareTelephonyTelephonySpare> => {
    return this.ovh.request('GET', `/telephony/spare/${spare}`);
  };

  /** Return the list of phone domains compatible to be replaced */
  getSpareCompatibleReplacementBySpare = (spare: string): Promise<string[]> => {
    return this.ovh.request('GET', `/telephony/spare/${spare}/compatibleReplacement`);
  };

  /** Replace the phone by its spare. The broken phone became a spare if it was bought. An RMA is created if the broken phone is under securitydeposit. */
  postSpareReplaceBySpare = (
    spare: string,
    body: { domain: string; ip: string }
  ): Promise<void> => {
    return this.ovh.request('POST', `/telephony/spare/${spare}/replace`, body);
  };

  /** Get this object properties */
  getSpareServiceInfosBySpare = (spare: string): Promise<ServicesService> => {
    return this.ovh.request('GET', `/telephony/spare/${spare}/serviceInfos`);
  };

  /** Alter this object properties */
  updateSpareServiceInfosBySpare = (spare: string, body: ServicesService): Promise<void> => {
    return this.ovh.request('PUT', `/telephony/spare/${spare}/serviceInfos`, body);
  };

  /** List available services */
  listTrunks = (): Promise<string[]> => {
    return this.ovh.request('GET', '/telephony/trunks');
  };

  /** Get this object properties */
  getTrunksByServiceName = (serviceName: string): Promise<TelephonyTelephonyGenericService> => {
    return this.ovh.request('GET', `/telephony/trunks/${serviceName}`);
  };

  /** Launch a contact change procedure */
  launchTrunksChangeContactByServiceName = (
    serviceName: string,
    body: { contactAdmin?: string; contactBilling?: string; contactTech?: string }
  ): Promise<number[]> => {
    return this.ovh.request('POST', `/telephony/trunks/${serviceName}/changeContact`, body);
  };

  /** Get this object properties */
  getTrunksServiceInfosByServiceName = (serviceName: string): Promise<ServicesService> => {
    return this.ovh.request('GET', `/telephony/trunks/${serviceName}/serviceInfos`);
  };

  /** Alter this object properties */
  updateTrunksServiceInfosByServiceName = (
    serviceName: string,
    body: ServicesService
  ): Promise<void> => {
    return this.ovh.request('PUT', `/telephony/trunks/${serviceName}/serviceInfos`, body);
  };

  /** Ask for a billing account termination. */
  deleteByBillingAccount = (billingAccount: string): Promise<void> => {
    return this.ovh.request('DELETE', `/telephony/${billingAccount}`);
  };

  /** Get this object properties */
  getByBillingAccount = (billingAccount: string): Promise<TelephonyBillingAccount> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}`);
  };

  /** Alter this object properties */
  updateByBillingAccount = (
    billingAccount: string,
    body: TelephonyBillingAccount
  ): Promise<void> => {
    return this.ovh.request('PUT', `/telephony/${billingAccount}`, body);
  };

  /** Abbreviated numbers for the billing account */
  getAbbreviatedNumberByBillingAccount = (billingAccount: string): Promise<number[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/abbreviatedNumber`);
  };

  /** Create a new abbreviated number for the billing account */
  createAbbreviatedNumberByBillingAccount = (
    billingAccount: string,
    body: { abbreviatedNumber: number; destinationNumber: string; name: string; surname: string }
  ): Promise<TelephonyAbbreviatedNumberGroup> => {
    return this.ovh.request('POST', `/telephony/${billingAccount}/abbreviatedNumber`, body);
  };

  /** Delete the given abbreviated number */
  deleteAbbreviatedNumberByBillingAccountAndAbbreviatedNumber = (
    abbreviatedNumber: number,
    billingAccount: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/abbreviatedNumber/${abbreviatedNumber}`
    );
  };

  /** Get this object properties */
  getAbbreviatedNumberByBillingAccountAndAbbreviatedNumber = (
    abbreviatedNumber: number,
    billingAccount: string
  ): Promise<TelephonyAbbreviatedNumberGroup> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/abbreviatedNumber/${abbreviatedNumber}`
    );
  };

  /** Alter this object properties */
  updateAbbreviatedNumberByBillingAccountAndAbbreviatedNumber = (
    abbreviatedNumber: number,
    billingAccount: string,
    body: TelephonyAbbreviatedNumberGroup
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/abbreviatedNumber/${abbreviatedNumber}`,
      body
    );
  };

  /** Get the allowed creditThreshold for this billing account */
  getAllowedCreditThresholdByBillingAccount = (billingAccount: string): Promise<OrderPrice[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/allowedCreditThreshold`);
  };

  /** Give all amounts availables for your billing account */
  getAmountSecurityDepositByBillingAccount = (billingAccount: string): Promise<OrderPrice[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/amountSecurityDeposit`);
  };

  /** Current billing account site (billing account features are overwritten by the site) */
  getBillingAccountSiteByBillingAccount = (billingAccount: string): Promise<string> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/billingAccountSite`);
  };

  /** Used to overwrite current billing account feature by the billing account site */
  postBillingAccountSiteByBillingAccount = (
    billingAccount: string,
    body: { billingAccountSite: string }
  ): Promise<void> => {
    return this.ovh.request('POST', `/telephony/${billingAccount}/billingAccountSite`, body);
  };

  /** Check if security deposit transfer is possible between two billing accounts */
  checkCanTransferSecurityDepositByBillingAccount = (
    billingAccount: string,
    body: { billingAccountDestination: string }
  ): Promise<boolean> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/canTransferSecurityDeposit`,
      body
    );
  };

  /** Cancel the billing account termination */
  postCancelTerminationByBillingAccount = (billingAccount: string): Promise<void> => {
    return this.ovh.request('POST', `/telephony/${billingAccount}/cancelTermination`);
  };

  /** Carrier SIP trunks associated with this billing account */
  getCarrierSipByBillingAccount = (billingAccount: string): Promise<string[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/carrierSip`);
  };

  /** Get this object properties */
  getCarrierSipByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyCarrierSip> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/carrierSip/${serviceName}`);
  };

  /** Get the Call Detail Records of your Carrier SIP service */
  getCarrierSipCdrsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyDocument> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/carrierSip/${serviceName}/cdrs`);
  };

  /** Get details about the carrier sip cluster of your stack */
  getCarrierSipClusterDetailsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyCarrierSipClusterInfo> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/carrierSip/${serviceName}/clusterDetails`
    );
  };

  /** List of your remote sip endpoints (ips, ports, protocol) of your carrier sip trunk service */
  listCarrierSipEndpointsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/carrierSip/${serviceName}/endpoints`
    );
  };

  /** Get this object properties */
  getCarrierSipEndpointsByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyCarrierSipCustomerEndpoint> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/carrierSip/${serviceName}/endpoints/${id}`
    );
  };

  /** Get this object properties */
  getCarrierSipSettingsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyCarrierSipDetails> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/carrierSip/${serviceName}/settings`
    );
  };

  /** Alter this object properties */
  updateCarrierSipSettingsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyCarrierSipDetails
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/carrierSip/${serviceName}/settings`,
      body
    );
  };

  /** Launch a contact change procedure */
  launchChangeContactByBillingAccount = (
    billingAccount: string,
    body: { contactAdmin?: string; contactBilling?: string; contactTech?: string }
  ): Promise<number[]> => {
    return this.ovh.request('POST', `/telephony/${billingAccount}/changeContact`, body);
  };

  /** Conferences associated with this billing account */
  getConferenceByBillingAccount = (billingAccount: string): Promise<string[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/conference`);
  };

  /** Get this object properties */
  getConferenceByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyConference> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/conference/${serviceName}`);
  };

  /** Change the sound played at the beginning of the conference */
  updateConferenceAnnounceUploadByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { documentId: string }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/conference/${serviceName}/announceUpload`,
      body
    );
  };

  /** List your past conferences for this number */
  listConferenceHistoriesByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/conference/${serviceName}/histories`
    );
  };

  /** Get this object properties */
  getConferenceHistoriesByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyConferenceHistory> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/conference/${serviceName}/histories/${id}`
    );
  };

  /** Get realtime conference informations */
  getConferenceInformationsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyConferenceInformations> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/conference/${serviceName}/informations`
    );
  };

  /** Lock the conference room */
  postConferenceLockByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyTask> => {
    return this.ovh.request('POST', `/telephony/${billingAccount}/conference/${serviceName}/lock`);
  };

  /** Current participants of the associate conference */
  getConferenceParticipantsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/conference/${serviceName}/participants`
    );
  };

  /** Get this object properties */
  getConferenceParticipantsByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyConferenceParticipants> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/conference/${serviceName}/participants/${id}`
    );
  };

  /** Make a participant deaf in your conference room */
  postConferenceParticipantsDeafByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/conference/${serviceName}/participants/${id}/deaf`
    );
  };

  /** Change a participant level of audio transmission */
  updateConferenceParticipantsEnergyByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string,
    body: { value: number }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/conference/${serviceName}/participants/${id}/energy`,
      body
    );
  };

  /** Eject a participant from your conference room */
  postConferenceParticipantsKickByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/conference/${serviceName}/participants/${id}/kick`
    );
  };

  /** Mute a participant in your conference room */
  postConferenceParticipantsMuteByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/conference/${serviceName}/participants/${id}/mute`
    );
  };

  /** Make a participant undeaf your conference room */
  postConferenceParticipantsUndeafByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/conference/${serviceName}/participants/${id}/undeaf`
    );
  };

  /** Unmute a participant in your conference room */
  postConferenceParticipantsUnmuteByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/conference/${serviceName}/participants/${id}/unmute`
    );
  };

  /** List your conferences rooms for this number */
  listConferenceRoomsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/conference/${serviceName}/rooms`);
  };

  /** Create a new conference room on your conference service */
  createConferenceRoomsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { roomNumber?: number }
  ): Promise<TelephonyConferenceRoom> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/conference/${serviceName}/rooms`,
      body
    );
  };

  /** Get this object properties */
  getConferenceRoomsByBillingAccountAndServiceNameAndRoomNumber = (
    billingAccount: string,
    roomNumber: number,
    serviceName: string
  ): Promise<TelephonyConferenceRoom> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/conference/${serviceName}/rooms/${roomNumber}`
    );
  };

  /** Alter this object properties */
  updateConferenceRoomsByBillingAccountAndServiceNameAndRoomNumber = (
    billingAccount: string,
    roomNumber: number,
    serviceName: string,
    body: TelephonyConferenceRoom
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/conference/${serviceName}/rooms/${roomNumber}`,
      body
    );
  };

  /** List your past conferences for this room */
  listConferenceRoomsHistoriesByBillingAccountAndServiceNameAndRoomNumber = (
    billingAccount: string,
    roomNumber: number,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/conference/${serviceName}/rooms/${roomNumber}/histories`
    );
  };

  /** Get this object properties */
  getConferenceRoomsHistoriesByBillingAccountAndServiceNameAndRoomNumberAndId = (
    billingAccount: string,
    id: number,
    roomNumber: number,
    serviceName: string
  ): Promise<TelephonyConferenceHistory> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/conference/${serviceName}/rooms/${roomNumber}/histories/${id}`
    );
  };

  /** Lock the conference room */
  postConferenceRoomsLockByBillingAccountAndServiceNameAndRoomNumber = (
    billingAccount: string,
    roomNumber: number,
    serviceName: string
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/conference/${serviceName}/rooms/${roomNumber}/lock`
    );
  };

  /** Current participants of the conference room */
  getConferenceRoomsParticipantsByBillingAccountAndServiceNameAndRoomNumber = (
    billingAccount: string,
    roomNumber: number,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/conference/${serviceName}/rooms/${roomNumber}/participants`
    );
  };

  /** Get this object properties */
  getConferenceRoomsParticipantsByBillingAccountAndServiceNameAndRoomNumberAndId = (
    billingAccount: string,
    id: number,
    roomNumber: number,
    serviceName: string
  ): Promise<TelephonyConferenceParticipants> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/conference/${serviceName}/rooms/${roomNumber}/participants/${id}`
    );
  };

  /** Make a participant deaf in your conference room */
  postConferenceRoomsParticipantsDeafByBillingAccountAndServiceNameAndRoomNumberAndId = (
    billingAccount: string,
    id: number,
    roomNumber: number,
    serviceName: string
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/conference/${serviceName}/rooms/${roomNumber}/participants/${id}/deaf`
    );
  };

  /** Change a participant level of audio transmission */
  updateConferenceRoomsParticipantsEnergyByBillingAccountAndServiceNameAndRoomNumberAndId = (
    billingAccount: string,
    id: number,
    roomNumber: number,
    serviceName: string,
    body: { value: number }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/conference/${serviceName}/rooms/${roomNumber}/participants/${id}/energy`,
      body
    );
  };

  /** Eject a participant from your conference room */
  postConferenceRoomsParticipantsKickByBillingAccountAndServiceNameAndRoomNumberAndId = (
    billingAccount: string,
    id: number,
    roomNumber: number,
    serviceName: string
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/conference/${serviceName}/rooms/${roomNumber}/participants/${id}/kick`
    );
  };

  /** Mute a participant in your conference room */
  postConferenceRoomsParticipantsMuteByBillingAccountAndServiceNameAndRoomNumberAndId = (
    billingAccount: string,
    id: number,
    roomNumber: number,
    serviceName: string
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/conference/${serviceName}/rooms/${roomNumber}/participants/${id}/mute`
    );
  };

  /** Make a participant undeaf your conference room */
  postConferenceRoomsParticipantsUndeafByBillingAccountAndServiceNameAndRoomNumberAndId = (
    billingAccount: string,
    id: number,
    roomNumber: number,
    serviceName: string
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/conference/${serviceName}/rooms/${roomNumber}/participants/${id}/undeaf`
    );
  };

  /** Unmute a participant in your conference room */
  postConferenceRoomsParticipantsUnmuteByBillingAccountAndServiceNameAndRoomNumberAndId = (
    billingAccount: string,
    id: number,
    roomNumber: number,
    serviceName: string
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/conference/${serviceName}/rooms/${roomNumber}/participants/${id}/unmute`
    );
  };

  /** Unlock the conference room */
  postConferenceRoomsUnlockByBillingAccountAndServiceNameAndRoomNumber = (
    billingAccount: string,
    roomNumber: number,
    serviceName: string
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/conference/${serviceName}/rooms/${roomNumber}/unlock`
    );
  };

  /** List your conference room  web access */
  listConferenceRoomsWebAccessByBillingAccountAndServiceNameAndRoomNumber = (
    billingAccount: string,
    roomNumber: number,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/conference/${serviceName}/rooms/${roomNumber}/webAccess`
    );
  };

  /** Add a public web access to your conference */
  addConferenceRoomsWebAccessByBillingAccountAndServiceNameAndRoomNumber = (
    billingAccount: string,
    roomNumber: number,
    serviceName: string,
    body: { type: TelephonyConferenceWebAccessTypeEnum }
  ): Promise<TelephonyConferenceWebAccess> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/conference/${serviceName}/rooms/${roomNumber}/webAccess`,
      body
    );
  };

  /** Delete a public web access to your conference */
  deleteConferenceRoomsWebAccessByBillingAccountAndServiceNameAndRoomNumberAndId = (
    billingAccount: string,
    id: number,
    roomNumber: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/conference/${serviceName}/rooms/${roomNumber}/webAccess/${id}`
    );
  };

  /** Get this object properties */
  getConferenceRoomsWebAccessByBillingAccountAndServiceNameAndRoomNumberAndId = (
    billingAccount: string,
    id: number,
    roomNumber: number,
    serviceName: string
  ): Promise<TelephonyConferenceWebAccess> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/conference/${serviceName}/rooms/${roomNumber}/webAccess/${id}`
    );
  };

  /** Get realtime statistics about all rooms of your conference number */
  getConferenceRoomsStatsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyConferenceRoomsStatistics> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/conference/${serviceName}/roomsStats`
    );
  };

  /** Get this object properties */
  getConferenceSettingsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyConferenceProperties> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/conference/${serviceName}/settings`
    );
  };

  /** Alter this object properties */
  updateConferenceSettingsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyConferenceProperties
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/conference/${serviceName}/settings`,
      body
    );
  };

  /** Unlock the conference room */
  postConferenceUnlockByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/conference/${serviceName}/unlock`
    );
  };

  /** List your conference web access */
  listConferenceWebAccessByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/conference/${serviceName}/webAccess`
    );
  };

  /** Add a public web access to your conference */
  addConferenceWebAccessByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { type: TelephonyConferenceWebAccessTypeEnum }
  ): Promise<TelephonyConferenceWebAccess> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/conference/${serviceName}/webAccess`,
      body
    );
  };

  /** Delete a public web access to your conference */
  deleteConferenceWebAccessByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/conference/${serviceName}/webAccess/${id}`
    );
  };

  /** Get this object properties */
  getConferenceWebAccessByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyConferenceWebAccess> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/conference/${serviceName}/webAccess/${id}`
    );
  };

  /** DDIs (direct dial-in) associated with this billing account */
  getDdiByBillingAccount = (billingAccount: string): Promise<string[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/ddi`);
  };

  /** Get this object properties */
  getDdiByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyDdi> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/ddi/${serviceName}`);
  };

  /** Alter this object properties */
  updateDdiByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyDdi
  ): Promise<void> => {
    return this.ovh.request('PUT', `/telephony/${billingAccount}/ddi/${serviceName}`, body);
  };

  /** Change the destination of the DDI */
  updateDdiDestinationByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { destination: string }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/ddi/${serviceName}/changeDestination`,
      body
    );
  };

  /** OVH easy calls queues associated with this billing account */
  getEasyHuntingByBillingAccount = (billingAccount: string): Promise<string[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/easyHunting`);
  };

  /** Get this object properties */
  getEasyHuntingByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyEasyHunting> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/easyHunting/${serviceName}`);
  };

  /** Alter this object properties */
  updateEasyHuntingByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyEasyHunting
  ): Promise<void> => {
    return this.ovh.request('PUT', `/telephony/${billingAccount}/easyHunting/${serviceName}`, body);
  };

  /** Get this object properties */
  getEasyHuntingHuntingByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyOvhPabxHunting> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting`
    );
  };

  /** Alter this object properties */
  updateEasyHuntingHuntingByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyOvhPabxHunting
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting`,
      body
    );
  };

  /** Calls agents */
  getEasyHuntingHuntingAgentByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/agent`
    );
  };

  /** Create a new agent */
  createEasyHuntingHuntingAgentByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: {
      description?: string;
      number: string;
      simultaneousLines: number;
      status: TelephonyOvhPabxHuntingAgentStatusEnum;
      timeout: number;
      wrapUpTime: number;
    }
  ): Promise<TelephonyOvhPabxHuntingAgent> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/agent`,
      body
    );
  };

  /** Delete the given agent */
  deleteEasyHuntingHuntingAgentByBillingAccountAndServiceNameAndAgentId = (
    agentId: number,
    billingAccount: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/agent/${agentId}`
    );
  };

  /** Get this object properties */
  getEasyHuntingHuntingAgentByBillingAccountAndServiceNameAndAgentId = (
    agentId: number,
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyOvhPabxHuntingAgent> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/agent/${agentId}`
    );
  };

  /** Alter this object properties */
  updateEasyHuntingHuntingAgentByBillingAccountAndServiceNameAndAgentId = (
    agentId: number,
    billingAccount: string,
    serviceName: string,
    body: TelephonyOvhPabxHuntingAgent
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/agent/${agentId}`,
      body
    );
  };

  /** Delete the given web access */
  deleteEasyHuntingHuntingAgentBannerAccessByBillingAccountAndServiceNameAndAgentId = (
    agentId: number,
    billingAccount: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/agent/${agentId}/bannerAccess`
    );
  };

  /** Get this object properties */
  getEasyHuntingHuntingAgentBannerAccessByBillingAccountAndServiceNameAndAgentId = (
    agentId: number,
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyBannerAccess> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/agent/${agentId}/bannerAccess`
    );
  };

  /** Create a new web access for this ressource */
  createEasyHuntingHuntingAgentBannerAccessByBillingAccountAndServiceNameAndAgentId = (
    agentId: number,
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyBannerAccess> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/agent/${agentId}/bannerAccess`
    );
  };

  /** Current calls of the callcenter agent */
  getEasyHuntingHuntingAgentCallsByBillingAccountAndServiceNameAndAgentId = (
    agentId: number,
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/agent/${agentId}/calls`
    );
  };

  /** Get this object properties */
  getEasyHuntingHuntingAgentCallsByBillingAccountAndServiceNameAndAgentIdAndId = (
    agentId: number,
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyOvhPabxHuntingQueueLiveCalls> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/agent/${agentId}/calls/${id}`
    );
  };

  /** Eavesdrop on a call */
  postEasyHuntingHuntingAgentCallsEavesdropByBillingAccountAndServiceNameAndAgentIdAndId = (
    agentId: number,
    billingAccount: string,
    id: number,
    serviceName: string,
    body: { number: string }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/agent/${agentId}/calls/${id}/eavesdrop`,
      body
    );
  };

  /** Hangup a call */
  postEasyHuntingHuntingAgentCallsHangupByBillingAccountAndServiceNameAndAgentIdAndId = (
    agentId: number,
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/agent/${agentId}/calls/${id}/hangup`
    );
  };

  /** Toogle hold on call */
  postEasyHuntingHuntingAgentCallsHoldByBillingAccountAndServiceNameAndAgentIdAndId = (
    agentId: number,
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/agent/${agentId}/calls/${id}/hold`
    );
  };

  /** Intercept a non answered call */
  postEasyHuntingHuntingAgentCallsInterceptByBillingAccountAndServiceNameAndAgentIdAndId = (
    agentId: number,
    billingAccount: string,
    id: number,
    serviceName: string,
    body: { number: string }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/agent/${agentId}/calls/${id}/intercept`,
      body
    );
  };

  /** Transfer an answered call */
  postEasyHuntingHuntingAgentCallsTransferByBillingAccountAndServiceNameAndAgentIdAndId = (
    agentId: number,
    billingAccount: string,
    id: number,
    serviceName: string,
    body: { number: string }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/agent/${agentId}/calls/${id}/transfer`,
      body
    );
  };

  /** Whisper on a call */
  postEasyHuntingHuntingAgentCallsWhisperByBillingAccountAndServiceNameAndAgentIdAndId = (
    agentId: number,
    billingAccount: string,
    id: number,
    serviceName: string,
    body: { number: string; whisperingMode: TelephonyOvhPabxWhisperingModeEnum }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/agent/${agentId}/calls/${id}/whisper`,
      body
    );
  };

  /** Delete the given token */
  deleteEasyHuntingHuntingAgentEventTokenByBillingAccountAndServiceNameAndAgentId = (
    agentId: number,
    billingAccount: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/agent/${agentId}/eventToken`
    );
  };

  /** Get this object properties */
  getEasyHuntingHuntingAgentEventTokenByBillingAccountAndServiceNameAndAgentId = (
    agentId: number,
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyEventToken> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/agent/${agentId}/eventToken`
    );
  };

  /** Create a new token */
  createEasyHuntingHuntingAgentEventTokenByBillingAccountAndServiceNameAndAgentId = (
    agentId: number,
    billingAccount: string,
    serviceName: string,
    body: { expiration: TelephonyTokenExpirationEnum }
  ): Promise<string> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/agent/${agentId}/eventToken`,
      body
    );
  };

  /** Get this object properties */
  getEasyHuntingHuntingAgentLiveStatusByBillingAccountAndServiceNameAndAgentId = (
    agentId: number,
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyOvhPabxHuntingAgentLiveStatus> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/agent/${agentId}/liveStatus`
    );
  };

  /** Agent assigned to the queues */
  getEasyHuntingHuntingAgentQueueByBillingAccountAndServiceNameAndAgentId = (
    agentId: number,
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/agent/${agentId}/queue`
    );
  };

  /** Create a new skill for an agent (it adds the agent in a queue) */
  createEasyHuntingHuntingAgentQueueByBillingAccountAndServiceNameAndAgentId = (
    agentId: number,
    billingAccount: string,
    serviceName: string,
    body: { position: number; queueId: number }
  ): Promise<TelephonyOvhPabxHuntingAgentQueue> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/agent/${agentId}/queue`,
      body
    );
  };

  /** Delete the given skill */
  deleteEasyHuntingHuntingAgentQueueByBillingAccountAndServiceNameAndAgentIdAndQueueId = (
    agentId: number,
    billingAccount: string,
    queueId: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/agent/${agentId}/queue/${queueId}`
    );
  };

  /** Get this object properties */
  getEasyHuntingHuntingAgentQueueByBillingAccountAndServiceNameAndAgentIdAndQueueId = (
    agentId: number,
    billingAccount: string,
    queueId: number,
    serviceName: string
  ): Promise<TelephonyOvhPabxHuntingAgentQueue> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/agent/${agentId}/queue/${queueId}`
    );
  };

  /** Alter this object properties */
  updateEasyHuntingHuntingAgentQueueByBillingAccountAndServiceNameAndAgentIdAndQueueId = (
    agentId: number,
    billingAccount: string,
    queueId: number,
    serviceName: string,
    body: TelephonyOvhPabxHuntingAgentQueue
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/agent/${agentId}/queue/${queueId}`,
      body
    );
  };

  /** Get this object properties */
  getEasyHuntingHuntingAgentQueueLiveStatusByBillingAccountAndServiceNameAndAgentIdAndQueueId = (
    agentId: number,
    billingAccount: string,
    queueId: number,
    serviceName: string
  ): Promise<TelephonyOvhPabxHuntingAgentLiveStatus> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/agent/${agentId}/queue/${queueId}/liveStatus`
    );
  };

  /** Custom statuses of your agents */
  getEasyHuntingHuntingCustomStatusByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/customStatus`
    );
  };

  /** Create a new custom status */
  createEasyHuntingHuntingCustomStatusByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { color?: string; description?: string; name: string }
  ): Promise<TelephonyOvhPabxCustomStatus> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/customStatus`,
      body
    );
  };

  /** Delete the given custom status */
  deleteEasyHuntingHuntingCustomStatusByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/customStatus/${id}`
    );
  };

  /** Get this object properties */
  getEasyHuntingHuntingCustomStatusByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyOvhPabxCustomStatus> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/customStatus/${id}`
    );
  };

  /** Delete the given token */
  deleteEasyHuntingHuntingEventTokenByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/eventToken`
    );
  };

  /** Get this object properties */
  getEasyHuntingHuntingEventTokenByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyEventToken> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/eventToken`
    );
  };

  /** Create a new token */
  createEasyHuntingHuntingEventTokenByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { expiration: TelephonyTokenExpirationEnum }
  ): Promise<string> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/eventToken`,
      body
    );
  };

  /** Calls queues */
  getEasyHuntingHuntingQueueByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/queue`
    );
  };

  /** Create a new queue */
  createEasyHuntingHuntingQueueByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: {
      actionOnClosure?: TelephonyOvhPabxQueueActionEnum;
      actionOnClosureParam?: string;
      actionOnOverflow?: TelephonyOvhPabxQueueActionEnum;
      actionOnOverflowParam?: string;
      askForRecordDisabling?: boolean;
      description?: string;
      maxMember?: number;
      maxWaitTime?: number;
      record?: boolean;
      recordDisablingDigit?: TelephonyOvhPabxHuntingQueueRecordDisablingDigitEnum;
      recordDisablingLanguage?: TelephonyOvhPabxHuntingQueueRecordDisablingLanguageEnum;
      soundOnHold?: number;
      strategy: TelephonyOvhPabxHuntingQueueStrategyEnum;
    }
  ): Promise<TelephonyOvhPabxHuntingQueue> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/queue`,
      body
    );
  };

  /** Delete the given queue */
  deleteEasyHuntingHuntingQueueByBillingAccountAndServiceNameAndQueueId = (
    billingAccount: string,
    queueId: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/queue/${queueId}`
    );
  };

  /** Get this object properties */
  getEasyHuntingHuntingQueueByBillingAccountAndServiceNameAndQueueId = (
    billingAccount: string,
    queueId: number,
    serviceName: string
  ): Promise<TelephonyOvhPabxHuntingQueue> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/queue/${queueId}`
    );
  };

  /** Alter this object properties */
  updateEasyHuntingHuntingQueueByBillingAccountAndServiceNameAndQueueId = (
    billingAccount: string,
    queueId: number,
    serviceName: string,
    body: TelephonyOvhPabxHuntingQueue
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/queue/${queueId}`,
      body
    );
  };

  /** Agent assigned to the queue */
  getEasyHuntingHuntingQueueAgentByBillingAccountAndServiceNameAndQueueId = (
    billingAccount: string,
    queueId: number,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/queue/${queueId}/agent`
    );
  };

  /** Create a new skill for an agent (it adds the agent in a queue) */
  createEasyHuntingHuntingQueueAgentByBillingAccountAndServiceNameAndQueueId = (
    billingAccount: string,
    serviceName: string,
    body: { position: number; queueId: number }
  ): Promise<TelephonyOvhPabxHuntingAgentQueue> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/queue/${body.queueId}/agent`,
      body
    );
  };

  /** Delete the given skill */
  deleteEasyHuntingHuntingQueueAgentByBillingAccountAndServiceNameAndQueueIdAndAgentId = (
    agentId: number,
    billingAccount: string,
    queueId: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/queue/${queueId}/agent/${agentId}`
    );
  };

  /** Get this object properties */
  getEasyHuntingHuntingQueueAgentByBillingAccountAndServiceNameAndQueueIdAndAgentId = (
    agentId: number,
    billingAccount: string,
    queueId: number,
    serviceName: string
  ): Promise<TelephonyOvhPabxHuntingAgentQueue> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/queue/${queueId}/agent/${agentId}`
    );
  };

  /** Alter this object properties */
  updateEasyHuntingHuntingQueueAgentByBillingAccountAndServiceNameAndQueueIdAndAgentId = (
    agentId: number,
    billingAccount: string,
    queueId: number,
    serviceName: string,
    body: TelephonyOvhPabxHuntingAgentQueue
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/queue/${queueId}/agent/${agentId}`,
      body
    );
  };

  /** Get this object properties */
  getEasyHuntingHuntingQueueAgentLiveStatusByBillingAccountAndServiceNameAndQueueIdAndAgentId = (
    agentId: number,
    billingAccount: string,
    queueId: number,
    serviceName: string
  ): Promise<TelephonyOvhPabxHuntingAgentLiveStatus> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/queue/${queueId}/agent/${agentId}/liveStatus`
    );
  };

  /** Live calls of the queue */
  getEasyHuntingHuntingQueueLiveCallsByBillingAccountAndServiceNameAndQueueId = (
    billingAccount: string,
    queueId: number,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/queue/${queueId}/liveCalls`
    );
  };

  /** Get this object properties */
  getEasyHuntingHuntingQueueLiveCallsByBillingAccountAndServiceNameAndQueueIdAndId = (
    billingAccount: string,
    id: number,
    queueId: number,
    serviceName: string
  ): Promise<TelephonyOvhPabxHuntingQueueLiveCalls> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/queue/${queueId}/liveCalls/${id}`
    );
  };

  /** Eavesdrop on a call */
  postEasyHuntingHuntingQueueLiveCallsEavesdropByBillingAccountAndServiceNameAndQueueIdAndId = (
    billingAccount: string,
    id: number,
    queueId: number,
    serviceName: string,
    body: { number: string }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/queue/${queueId}/liveCalls/${id}/eavesdrop`,
      body
    );
  };

  /** Hangup a call */
  postEasyHuntingHuntingQueueLiveCallsHangupByBillingAccountAndServiceNameAndQueueIdAndId = (
    billingAccount: string,
    id: number,
    queueId: number,
    serviceName: string
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/queue/${queueId}/liveCalls/${id}/hangup`
    );
  };

  /** Toogle hold on call */
  postEasyHuntingHuntingQueueLiveCallsHoldByBillingAccountAndServiceNameAndQueueIdAndId = (
    billingAccount: string,
    id: number,
    queueId: number,
    serviceName: string
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/queue/${queueId}/liveCalls/${id}/hold`
    );
  };

  /** Intercept a non answered call */
  postEasyHuntingHuntingQueueLiveCallsInterceptByBillingAccountAndServiceNameAndQueueIdAndId = (
    billingAccount: string,
    id: number,
    queueId: number,
    serviceName: string,
    body: { number: string }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/queue/${queueId}/liveCalls/${id}/intercept`,
      body
    );
  };

  /** Transfer an answered call */
  postEasyHuntingHuntingQueueLiveCallsTransferByBillingAccountAndServiceNameAndQueueIdAndId = (
    billingAccount: string,
    id: number,
    queueId: number,
    serviceName: string,
    body: { number: string }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/queue/${queueId}/liveCalls/${id}/transfer`,
      body
    );
  };

  /** Whisper on a call */
  postEasyHuntingHuntingQueueLiveCallsWhisperByBillingAccountAndServiceNameAndQueueIdAndId = (
    billingAccount: string,
    id: number,
    queueId: number,
    serviceName: string,
    body: { number: string; whisperingMode: TelephonyOvhPabxWhisperingModeEnum }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/queue/${queueId}/liveCalls/${id}/whisper`,
      body
    );
  };

  /** Get this object properties */
  getEasyHuntingHuntingQueueLiveStatisticsByBillingAccountAndServiceNameAndQueueId = (
    billingAccount: string,
    queueId: number,
    serviceName: string
  ): Promise<TelephonyOvhPabxHuntingQueueLiveStatistics> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/hunting/queue/${queueId}/liveStatistics`
    );
  };

  /** Records associated with this PABX */
  getEasyHuntingRecordsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/records`
    );
  };

  /** Delete the given record */
  deleteEasyHuntingRecordsByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/records/${id}`
    );
  };

  /** Get this object properties */
  getEasyHuntingRecordsByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyOvhPabxRecord> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/records/${id}`
    );
  };

  /** Get this object properties */
  getEasyHuntingScreenListConditionsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyEasyHuntingScreenListsConditionsSettings> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/screenListConditions`
    );
  };

  /** Alter this object properties */
  updateEasyHuntingScreenListConditionsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyEasyHuntingScreenListsConditionsSettings
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/screenListConditions`,
      body
    );
  };

  /** Screen lists conditions checked when a call is received */
  getEasyHuntingScreenListConditionsConditionsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/screenListConditions/conditions`
    );
  };

  /** Create a new screenlist condition for an extension */
  createEasyHuntingScreenListConditionsConditionsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: {
      callerIdNumber?: string;
      destinationNumber?: string;
      screenListType: TelephonyOvhPabxDialplanExtensionConditionScreenListTypeEnum;
    }
  ): Promise<TelephonyEasyHuntingScreenListsConditions> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/screenListConditions/conditions`,
      body
    );
  };

  /** Delete the given condition */
  deleteEasyHuntingScreenListConditionsConditionsByBillingAccountAndServiceNameAndConditionId = (
    billingAccount: string,
    conditionId: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/screenListConditions/conditions/${conditionId}`
    );
  };

  /** Get this object properties */
  getEasyHuntingScreenListConditionsConditionsByBillingAccountAndServiceNameAndConditionId = (
    billingAccount: string,
    conditionId: number,
    serviceName: string
  ): Promise<TelephonyEasyHuntingScreenListsConditions> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/screenListConditions/conditions/${conditionId}`
    );
  };

  /** Alter this object properties */
  updateEasyHuntingScreenListConditionsConditionsByBillingAccountAndServiceNameAndConditionId = (
    billingAccount: string,
    conditionId: number,
    serviceName: string,
    body: TelephonyEasyHuntingScreenListsConditions
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/screenListConditions/conditions/${conditionId}`,
      body
    );
  };

  /** Sounds associated with this PABX */
  getEasyHuntingSoundByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/easyHunting/${serviceName}/sound`);
  };

  /** Delete the given sound */
  deleteEasyHuntingSoundByBillingAccountAndServiceNameAndSoundId = (
    billingAccount: string,
    serviceName: string,
    soundId: number
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/sound/${soundId}`
    );
  };

  /** Get this object properties */
  getEasyHuntingSoundByBillingAccountAndServiceNameAndSoundId = (
    billingAccount: string,
    serviceName: string,
    soundId: number
  ): Promise<TelephonyOvhPabxSound> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/sound/${soundId}`
    );
  };

  /** Upload new sound file */
  postEasyHuntingSoundUploadByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { documentId?: string; name?: string; url?: string }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/soundUpload`,
      body
    );
  };

  /** Get this object properties */
  getEasyHuntingTimeConditionsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyEasyHuntingTimeConditionsSettings> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/timeConditions`
    );
  };

  /** Alter this object properties */
  updateEasyHuntingTimeConditionsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyEasyHuntingTimeConditionsSettings
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/timeConditions`,
      body
    );
  };

  /** Time conditions checked when a call is received */
  getEasyHuntingTimeConditionsConditionsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/timeConditions/conditions`
    );
  };

  /** Create a new time condition */
  createEasyHuntingTimeConditionsConditionsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: {
      policy: TelephonyTimeConditionsPolicyEnum;
      timeFrom: Date;
      timeTo: Date;
      weekDay: TelephonyOvhPabxDialplanExtensionConditionTimeWeekDayEnum;
    }
  ): Promise<TelephonyEasyHuntingTimeConditions> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/timeConditions/conditions`,
      body
    );
  };

  /** Delete the given condition */
  deleteEasyHuntingTimeConditionsConditionsByBillingAccountAndServiceNameAndConditionId = (
    billingAccount: string,
    conditionId: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/timeConditions/conditions/${conditionId}`
    );
  };

  /** Get this object properties */
  getEasyHuntingTimeConditionsConditionsByBillingAccountAndServiceNameAndConditionId = (
    billingAccount: string,
    conditionId: number,
    serviceName: string
  ): Promise<TelephonyEasyHuntingTimeConditions> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/timeConditions/conditions/${conditionId}`
    );
  };

  /** Alter this object properties */
  updateEasyHuntingTimeConditionsConditionsByBillingAccountAndServiceNameAndConditionId = (
    billingAccount: string,
    conditionId: number,
    serviceName: string,
    body: TelephonyEasyHuntingTimeConditions
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/easyHunting/${serviceName}/timeConditions/conditions/${conditionId}`,
      body
    );
  };

  /** EasyPabx associated with this billing account */
  getEasyPabxByBillingAccount = (billingAccount: string): Promise<string[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/easyPabx`);
  };

  /** Get this object properties */
  getEasyPabxByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyEasyPabx> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/easyPabx/${serviceName}`);
  };

  /** Alter this object properties */
  updateEasyPabxByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyEasyPabx
  ): Promise<void> => {
    return this.ovh.request('PUT', `/telephony/${billingAccount}/easyPabx/${serviceName}`, body);
  };

  /** Get this object properties */
  getEasyPabxHuntingByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyEasyPabxHunting> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/easyPabx/${serviceName}/hunting`);
  };

  /** Alter this object properties */
  updateEasyPabxHuntingByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyEasyPabxHunting
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/easyPabx/${serviceName}/hunting`,
      body
    );
  };

  /** Hunting agents */
  getEasyPabxHuntingAgentByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyPabx/${serviceName}/hunting/agent`
    );
  };

  /** Create a new agent */
  createEasyPabxHuntingAgentByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { agentNumber: string; logged: boolean; noReplyTimer: number; position: number }
  ): Promise<TelephonyEasyMiniPabxHuntingAgent> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/easyPabx/${serviceName}/hunting/agent`,
      body
    );
  };

  /** Delete the agent */
  deleteEasyPabxHuntingAgentByBillingAccountAndServiceNameAndAgentNumber = (
    agentNumber: string,
    billingAccount: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/easyPabx/${serviceName}/hunting/agent/${agentNumber}`
    );
  };

  /** Get this object properties */
  getEasyPabxHuntingAgentByBillingAccountAndServiceNameAndAgentNumber = (
    agentNumber: string,
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyEasyMiniPabxHuntingAgent> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyPabx/${serviceName}/hunting/agent/${agentNumber}`
    );
  };

  /** Alter this object properties */
  updateEasyPabxHuntingAgentByBillingAccountAndServiceNameAndAgentNumber = (
    agentNumber: string,
    billingAccount: string,
    serviceName: string,
    body: TelephonyEasyMiniPabxHuntingAgent
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/easyPabx/${serviceName}/hunting/agent/${agentNumber}`,
      body
    );
  };

  /** Get this object properties */
  getEasyPabxHuntingTonesByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyTones> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/easyPabx/${serviceName}/hunting/tones`
    );
  };

  /** Alter this object properties */
  updateEasyPabxHuntingTonesByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyTones
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/easyPabx/${serviceName}/hunting/tones`,
      body
    );
  };

  /** Upload new tone file */
  postEasyPabxHuntingTonesToneUploadByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { documentId?: string; type: TelephonyTonesTypeEnum; url?: string }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/easyPabx/${serviceName}/hunting/tones/toneUpload`,
      body
    );
  };

  /** Delete the given token */
  deleteEventTokenByBillingAccount = (billingAccount: string): Promise<void> => {
    return this.ovh.request('DELETE', `/telephony/${billingAccount}/eventToken`);
  };

  /** Get this object properties */
  getEventTokenByBillingAccount = (billingAccount: string): Promise<TelephonyEventToken> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/eventToken`);
  };

  /** Create a new token */
  createEventTokenByBillingAccount = (
    billingAccount: string,
    body: { expiration: TelephonyTokenExpirationEnum }
  ): Promise<string> => {
    return this.ovh.request('POST', `/telephony/${billingAccount}/eventToken`, body);
  };

  /** Faxes associated with this billing account */
  getFaxByBillingAccount = (billingAccount: string): Promise<string[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/fax`);
  };

  /** Get this object properties */
  getFaxByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyFax> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/fax/${serviceName}`);
  };

  /** Alter this object properties */
  updateFaxByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyFax
  ): Promise<void> => {
    return this.ovh.request('PUT', `/telephony/${billingAccount}/fax/${serviceName}`, body);
  };

  /** Fax campaigns of the associate fax */
  getFaxCampaignsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/fax/${serviceName}/campaigns`);
  };

  /** Create a new fax campaign */
  createFaxCampaignsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: {
      documentId: string;
      faxQuality?: TelephonyFaxQualityEnum;
      name: string;
      recipientsDocId?: string;
      recipientsList?: string[];
      recipientsType: TelephonyFaxCampaignRecipientsTypeEnum;
      sendDate?: Date;
      sendType: TelephonyFaxCampaignSendTypeEnum;
    }
  ): Promise<TelephonyFaxCampaign> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/fax/${serviceName}/campaigns`,
      body
    );
  };

  /** Delete a fax campaign */
  deleteFaxCampaignsByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/fax/${serviceName}/campaigns/${id}`
    );
  };

  /** Get this object properties */
  getFaxCampaignsByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyFaxCampaign> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/fax/${serviceName}/campaigns/${id}`
    );
  };

  /** Detail of the fax recipients by status */
  getFaxCampaignsDetailByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyFaxCampaignDetail> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/fax/${serviceName}/campaigns/${id}/detail`
    );
  };

  /** Start a fax campaign */
  postFaxCampaignsStartByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/fax/${serviceName}/campaigns/${id}/start`
    );
  };

  /** Stop a fax campaign */
  postFaxCampaignsStopByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/fax/${serviceName}/campaigns/${id}/stop`
    );
  };

  /** Delete all fax screenLists */
  deleteFaxScreenListsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/fax/${serviceName}/screenLists`
    );
  };

  /** Get this object properties */
  getFaxScreenListsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyFaxScreen> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/fax/${serviceName}/screenLists`);
  };

  /** Create a new fax ScreenLists */
  createFaxScreenListsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: {
      blacklistedNumbers?: string[];
      blacklistedTSI?: string[];
      filteringList?: TelephonyFaxScreenListTypeEnum;
      whitelistedNumbers?: string[];
      whitelistedTSI?: string[];
    }
  ): Promise<TelephonyFaxScreen> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/fax/${serviceName}/screenLists`,
      body
    );
  };

  /** Alter this object properties */
  updateFaxScreenListsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyFaxScreen
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/fax/${serviceName}/screenLists`,
      body
    );
  };

  /** Reset a specifical fax screenList */
  postFaxScreenListsResetByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: {
      blacklistedNumbers?: boolean;
      blacklistedTSI?: boolean;
      whitelistedNumbers?: boolean;
      whitelistedTSI?: boolean;
    }
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/fax/${serviceName}/screenLists/reset`,
      body
    );
  };

  /** Get this object properties */
  getFaxSettingsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyFaxProperties> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/fax/${serviceName}/settings`);
  };

  /** Alter this object properties */
  updateFaxSettingsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyFaxProperties
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/fax/${serviceName}/settings`,
      body
    );
  };

  /** Generates a new password for your fax account */
  postFaxSettingsChangePasswordByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { password?: string }
  ): Promise<string> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/fax/${serviceName}/settings/changePassword`,
      body
    );
  };

  /** Send a fax */
  sendFaxSettingsFaxByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { dateSchedule?: Date; pdfUrl: string; recipients: string[] }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/fax/${serviceName}/settings/sendFax`,
      body
    );
  };

  /** Check if the billing account contains at least one special number */
  checkHasSpecialNumbersByBillingAccount = (billingAccount: string): Promise<boolean> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/hasSpecialNumbers`);
  };

  /** Previous billed consumptions */
  getHistoryConsumptionByBillingAccount = (billingAccount: string): Promise<Date[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/historyConsumption`);
  };

  /** Get this object properties */
  getHistoryConsumptionByBillingAccountAndDate = (
    billingAccount: string,
    date: Date
  ): Promise<TelephonyHistoryConsumption> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/historyConsumption/${date}`);
  };

  /** Previous billed consumption files */
  getHistoryConsumptionFileByBillingAccountAndDate = (
    billingAccount: string,
    date: Date
  ): Promise<TelephonyPcsFile> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/historyConsumption/${date}/file`);
  };

  /** Previous repayment bill */
  getHistoryRepaymentConsumptionByBillingAccount = (billingAccount: string): Promise<Date[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/historyRepaymentConsumption`);
  };

  /** Ask for a new repayment */
  postHistoryRepaymentConsumptionByBillingAccount = (
    billingAccount: string,
    body: { billingNumber?: string }
  ): Promise<TelephonyHistoryRepaymentConsumption> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/historyRepaymentConsumption`,
      body
    );
  };

  /** Get this object properties */
  getHistoryRepaymentConsumptionByBillingAccountAndDate = (
    billingAccount: string,
    date: Date
  ): Promise<TelephonyHistoryRepaymentConsumption> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/historyRepaymentConsumption/${date}`
    );
  };

  /** Get the csv document */
  getHistoryRepaymentConsumptionDocumentByBillingAccountAndDate = (
    billingAccount: string,
    date: Date
  ): Promise<TelephonyPcsFile> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/historyRepaymentConsumption/${date}/document`
    );
  };

  /** Previous tollfree bill */
  getHistoryTollfreeConsumptionByBillingAccount = (billingAccount: string): Promise<Date[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/historyTollfreeConsumption`);
  };

  /** Get this object properties */
  getHistoryTollfreeConsumptionByBillingAccountAndDate = (
    billingAccount: string,
    date: Date
  ): Promise<TelephonyHistoryTollfreeConsumption> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/historyTollfreeConsumption/${date}`
    );
  };

  /** Get the csv document */
  getHistoryTollfreeConsumptionDocumentByBillingAccountAndDate = (
    billingAccount: string,
    date: Date
  ): Promise<TelephonyPcsFile> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/historyTollfreeConsumption/${date}/document`
    );
  };

  /** Lines associated with this billing account */
  getLineByBillingAccount = (billingAccount: string): Promise<string[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/line`);
  };

  /** Get this object properties */
  getLineByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyLine> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/line/${serviceName}`);
  };

  /** Alter this object properties */
  updateLineByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyLine
  ): Promise<void> => {
    return this.ovh.request('PUT', `/telephony/${billingAccount}/line/${serviceName}`, body);
  };

  /** Abbreviated numbers for the line */
  getLineAbbreviatedNumberByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/abbreviatedNumber`
    );
  };

  /** Create a new abbreviated number for the line */
  createLineAbbreviatedNumberByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { abbreviatedNumber: number; destinationNumber: string; name: string; surname: string }
  ): Promise<TelephonyAbbreviatedNumber> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/abbreviatedNumber`,
      body
    );
  };

  /** Delete the given abbreviated number */
  deleteLineAbbreviatedNumberByBillingAccountAndServiceNameAndAbbreviatedNumber = (
    abbreviatedNumber: number,
    billingAccount: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/line/${serviceName}/abbreviatedNumber/${abbreviatedNumber}`
    );
  };

  /** Get this object properties */
  getLineAbbreviatedNumberByBillingAccountAndServiceNameAndAbbreviatedNumber = (
    abbreviatedNumber: number,
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyAbbreviatedNumber> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/abbreviatedNumber/${abbreviatedNumber}`
    );
  };

  /** Alter this object properties */
  updateLineAbbreviatedNumberByBillingAccountAndServiceNameAndAbbreviatedNumber = (
    abbreviatedNumber: number,
    billingAccount: string,
    serviceName: string,
    body: TelephonyAbbreviatedNumber
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/line/${serviceName}/abbreviatedNumber/${abbreviatedNumber}`,
      body
    );
  };

  /** Check if there is a new phone to activate and if it's possible, in case of phone switch */
  checkLineActivateNewPhoneByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/activateNewPhone`
    );
  };

  /** Allow to activate new phone, in case of phone switch */
  postLineActivateNewPhoneByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/activateNewPhone`
    );
  };

  /** Current list of numbers or short code numbers restricted by an auto antihack */
  getLineAntihackByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/line/${serviceName}/antihack`);
  };

  /** Clean the antihack or add it on active filter screen list */
  postLineAntihackByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { action: TelephonyAntihackActionEnum; restricted?: string }
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/antihack`,
      body
    );
  };

  /** Associate a device to the current line with the device mac address */
  postLineAssociateDeviceByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { ipAddress?: string; macAddress: string; slot?: number }
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/associateDevice`,
      body
    );
  };

  /** Automatic Calls made by Calls Generator on this line */
  getLineAutomaticCallByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/automaticCall`
    );
  };

  /** Make an automatic phone call. Return generated call identifier */
  postLineAutomaticCallByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: {
      bridgeNumberDialplan?: string;
      calledNumber: string;
      callingNumber?: string;
      dialplan: TelephonyCallsGeneratorDialplanEnum;
      isAnonymous: boolean;
      playbackAudioFileDialplan?: string;
      timeout?: number;
      ttsTextDialplan?: string;
    }
  ): Promise<string> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/automaticCall`,
      body
    );
  };

  /** Get this object properties */
  getLineAutomaticCallByBillingAccountAndServiceNameAndIdentifier = (
    billingAccount: string,
    identifier: string,
    serviceName: string
  ): Promise<TelephonyCallsGenerated> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/automaticCall/${identifier}`
    );
  };

  /** Listing of domains Sip availables */
  listLineAvailableSipDomainsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/availableSipDomains`
    );
  };

  /** Block the line. By default it will block incoming and outgoing calls (except for emergency numbers) */
  postLineBlockByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { mode?: TelephonyLineBlockingMode }
  ): Promise<void> => {
    return this.ovh.request('POST', `/telephony/${billingAccount}/line/${serviceName}/block`, body);
  };

  /** The active calls of your line as a call center agent */
  getLineCallsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/line/${serviceName}/calls`);
  };

  /** Get this object properties */
  getLineCallsByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyOvhPabxHuntingQueueLiveCalls> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/line/${serviceName}/calls/${id}`);
  };

  /** Eavesdrop on a call */
  postLineCallsEavesdropByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string,
    body: { number: string }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/calls/${id}/eavesdrop`,
      body
    );
  };

  /** Hangup a call */
  postLineCallsHangupByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/calls/${id}/hangup`
    );
  };

  /** Toogle hold on call */
  postLineCallsHoldByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/calls/${id}/hold`
    );
  };

  /** Intercept a non answered call */
  postLineCallsInterceptByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string,
    body: { number: string }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/calls/${id}/intercept`,
      body
    );
  };

  /** Transfer an answered call */
  postLineCallsTransferByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string,
    body: { number: string }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/calls/${id}/transfer`,
      body
    );
  };

  /** Whisper on a call */
  postLineCallsWhisperByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string,
    body: { number: string; whisperingMode: TelephonyOvhPabxWhisperingModeEnum }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/calls/${id}/whisper`,
      body
    );
  };

  /** Ability to manage SIP password on this service */
  getLineCanChangePasswordByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<boolean> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/canChangePassword`
    );
  };

  /** Cancel a scheduled conversion to number */
  postLineCancelConvertToNumberByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/cancelConvertToNumber`
    );
  };

  /** Change the SIP account password. It must be more than 7 and less than 21 alpha and numerical characters. */
  updateLinePasswordByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { password?: string }
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/changePassword`,
      body
    );
  };

  /** Make a phone call from the current line */
  postLineClick2CallByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { calledNumber: string; callingNumber?: string; intercom?: boolean }
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/click2Call`,
      body
    );
  };

  /** User which can use click 2 call on the line */
  getLineClick2CallUserByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/click2CallUser`
    );
  };

  /** Create a new user for click 2 call */
  createLineClick2CallUserByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { login: string; password: string }
  ): Promise<number> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/click2CallUser`,
      body
    );
  };

  /** Delete a click 2 call user */
  deleteLineClick2CallUserByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/line/${serviceName}/click2CallUser/${id}`
    );
  };

  /** Get this object properties */
  getLineClick2CallUserByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyClick2CallUser> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/click2CallUser/${id}`
    );
  };

  /** Change the password of the click2call user */
  updateLineClick2CallUserPasswordByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string,
    body: { password: string }
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/click2CallUser/${id}/changePassword`,
      body
    );
  };

  /** Make a phone call from the current line */
  postLineClick2CallUserClick2CallByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string,
    body: { calledNumber: string; callingNumber?: string }
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/click2CallUser/${id}/click2Call`,
      body
    );
  };

  /** Schedule a conversion to number */
  postLineConvertToNumberByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyOfferTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/convertToNumber`
    );
  };

  /** Dissociate a device from the current line with the device mac address */
  postLineDissociateDeviceByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { ipAddress?: string; macAddress: string }
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/dissociateDevice`,
      body
    );
  };

  /** Listing of last ips registry */
  listLineIpsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyDatetimeAndIpvalue[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/line/${serviceName}/ips`);
  };

  /** List the informations about the last registrations (i.e. IP, port, User-Agent...) */
  listLineLastRegistrationsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyRegistrationInformations[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/lastRegistrations`
    );
  };

  /** List phones with available slots where this line can be attached */
  listLineAssociablePhonesByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyLinePhoneAssociable[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/listAssociablePhones`
    );
  };

  /** Get the maximum available simultaneous lines for this line */
  getLineMaximumAvailableSimultaneousLinesByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/maximumAvailableSimultaneousLines`
    );
  };

  /** Return public offer property */
  getLineOfferByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyLineOffer> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/line/${serviceName}/offer`);
  };

  /** Get this object properties */
  getLineOptionsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyLineOptions> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/line/${serviceName}/options`);
  };

  /** Alter this object properties */
  updateLineOptionsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyLineOptions
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/line/${serviceName}/options`,
      body
    );
  };

  /** List of codecs combinaisons available for this line */
  listLineOptionsAvailableCodecsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/options/availableCodecs`
    );
  };

  /** Get the default codecs for this line if none are set */
  getLineOptionsDefaultCodecsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<string> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/options/defaultCodecs`
    );
  };

  /** Get this object properties */
  getLinePhoneByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyPhone> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/line/${serviceName}/phone`);
  };

  /** Alter this object properties */
  updateLinePhoneByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyPhone
  ): Promise<void> => {
    return this.ovh.request('PUT', `/telephony/${billingAccount}/line/${serviceName}/phone`, body);
  };

  /** Returns the administration user and password of the phone if you are a VIP */
  getLinePhoneAdminCredentialsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyPhoneCredentials> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/phone/adminCredentials`
    );
  };

  /** Edit configuration of the phone remotely by provisioning */
  updateLinePhoneChangePhoneConfigurationByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { autoReboot?: boolean; newConfigurations?: string }
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/phone/changePhoneConfiguration`,
      body
    );
  };

  /** Plug & Phone function keys */
  getLinePhoneFunctionKeyByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/phone/functionKey`
    );
  };

  /** Get this object properties */
  getLinePhoneFunctionKeyByBillingAccountAndServiceNameAndKeyNum = (
    billingAccount: string,
    keyNum: number,
    serviceName: string
  ): Promise<TelephonyFunctionKey> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/phone/functionKey/${keyNum}`
    );
  };

  /** Alter this object properties */
  updateLinePhoneFunctionKeyByBillingAccountAndServiceNameAndKeyNum = (
    billingAccount: string,
    keyNum: number,
    serviceName: string,
    body: TelephonyFunctionKey
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/line/${serviceName}/phone/functionKey/${keyNum}`,
      body
    );
  };

  /** List the available functions for the key */
  listLinePhoneFunctionKeyAvailableFunctionByBillingAccountAndServiceNameAndKeyNum = (
    billingAccount: string,
    keyNum: number,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/phone/functionKey/${keyNum}/availableFunction`
    );
  };

  /** List of available exchange merchandise brand */
  listLinePhoneMerchandiseAvailableByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyHardwareOffer[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/phone/merchandiseAvailable`
    );
  };

  /** Return phonebooks associated */
  getLinePhonePhonebookByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/phone/phonebook`
    );
  };

  /** Add a phonebook. Return the bookKey. */
  addLinePhonePhonebookByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { name: string }
  ): Promise<string> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/phone/phonebook`,
      body
    );
  };

  /** Delete a phonebook */
  deleteLinePhonePhonebookByBillingAccountAndServiceNameAndBookKey = (
    billingAccount: string,
    bookKey: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/line/${serviceName}/phone/phonebook/${bookKey}`
    );
  };

  /** Get this object properties */
  getLinePhonePhonebookByBillingAccountAndServiceNameAndBookKey = (
    billingAccount: string,
    bookKey: string,
    serviceName: string
  ): Promise<TelephonyPhonebook> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/phone/phonebook/${bookKey}`
    );
  };

  /** Alter this object properties */
  updateLinePhonePhonebookByBillingAccountAndServiceNameAndBookKey = (
    billingAccount: string,
    bookKey: string,
    serviceName: string,
    body: TelephonyPhonebook
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/line/${serviceName}/phone/phonebook/${bookKey}`,
      body
    );
  };

  /** Export the phonebook's contacts */
  exportLinePhonePhonebookByBillingAccountAndServiceNameAndBookKey = (
    billingAccount: string,
    bookKey: string,
    serviceName: string
  ): Promise<TelephonyPcsFile> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/phone/phonebook/${bookKey}/export`
    );
  };

  /** Import a contacts file. Supported formats are Excel (.xls and .xlsx) and CSV */
  postLinePhonePhonebookImportByBillingAccountAndServiceNameAndBookKey = (
    billingAccount: string,
    bookKey: string,
    serviceName: string,
    body: { documentId: string }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/phone/phonebook/${bookKey}/import`,
      body
    );
  };

  /** Phonebook contacts */
  getLinePhonePhonebookPhonebookContactByBillingAccountAndServiceNameAndBookKey = (
    billingAccount: string,
    bookKey: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/phone/phonebook/${bookKey}/phonebookContact`
    );
  };

  /** Create a phonebook contact. Return identifier of the phonebook contact. */
  createLinePhonePhonebookPhonebookContactByBillingAccountAndServiceNameAndBookKey = (
    billingAccount: string,
    bookKey: string,
    serviceName: string,
    body: {
      group: string;
      homeMobile?: string;
      homePhone?: string;
      name: string;
      surname: string;
      workMobile?: string;
      workPhone?: string;
    }
  ): Promise<number> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/phone/phonebook/${bookKey}/phonebookContact`,
      body
    );
  };

  /** Delete a phonebook contact */
  deleteLinePhonePhonebookPhonebookContactByBillingAccountAndServiceNameAndBookKeyAndId = (
    billingAccount: string,
    bookKey: string,
    id: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/line/${serviceName}/phone/phonebook/${bookKey}/phonebookContact/${id}`
    );
  };

  /** Get this object properties */
  getLinePhonePhonebookPhonebookContactByBillingAccountAndServiceNameAndBookKeyAndId = (
    billingAccount: string,
    bookKey: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyPhonebookContact> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/phone/phonebook/${bookKey}/phonebookContact/${id}`
    );
  };

  /** Alter this object properties */
  updateLinePhonePhonebookPhonebookContactByBillingAccountAndServiceNameAndBookKeyAndId = (
    billingAccount: string,
    bookKey: string,
    id: number,
    serviceName: string,
    body: TelephonyPhonebookContact
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/line/${serviceName}/phone/phonebook/${bookKey}/phonebookContact/${id}`,
      body
    );
  };

  /** Create a task to reboot the phone */
  createLinePhoneRebootByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/phone/reboot`
    );
  };

  /** Create a task to refresh the screen of the MGCP phone */
  createLinePhoneRefreshScreenByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/phone/refreshScreen`
    );
  };

  /** Reinitialize the phone configuration */
  postLinePhoneResetConfigByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { ip: string }
  ): Promise<TelephonyResetPhoneInfo> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/phone/resetConfig`,
      body
    );
  };

  /** Return Merchandise Authorisation associated */
  getLinePhoneRmaByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/line/${serviceName}/phone/rma`);
  };

  /** Create a specific rma */
  createLinePhoneRmaByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: {
      mondialRelayId?: string;
      newMerchandise?: string;
      shippingContactId?: number;
      type: TelephonyRmaPublicTypeEnum;
    }
  ): Promise<TelephonyRmaReturn> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/phone/rma`,
      body
    );
  };

  /** Cancel the rma */
  deleteLinePhoneRmaByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/line/${serviceName}/phone/rma/${id}`
    );
  };

  /** Get this object properties */
  getLinePhoneRmaByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: string,
    serviceName: string
  ): Promise<TelephonyRma> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/phone/rma/${id}`
    );
  };

  /** Alter this object properties */
  updateLinePhoneRmaByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: string,
    serviceName: string,
    body: TelephonyRma
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/line/${serviceName}/phone/rma/${id}`,
      body
    );
  };

  /** Change RMA type */
  updateLinePhoneRmaTypeByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: string,
    serviceName: string,
    body: { type: TelephonyRmaChangeTypeEnum }
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/phone/rma/${id}/changeType`,
      body
    );
  };

  /** Does the phone manages phonebooks? */
  getLinePhoneSupportsPhonebookByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<boolean> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/phone/supportsPhonebook`
    );
  };

  /** List the phones with Sip slot available */
  listLinePhoneCanBeAssociableByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyLinePhone[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/phoneCanBeAssociable`
    );
  };

  /** The recordings of your line outgoing calls */
  getLineRecordsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/line/${serviceName}/records`);
  };

  /** Delete the given record */
  deleteLineRecordsByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/line/${serviceName}/records/${id}`
    );
  };

  /** Get this object properties */
  getLineRecordsByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyOvhPabxRecord> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/records/${id}`
    );
  };

  /** Remove extra simultaneous lines */
  postLineRemoveSimultaneousLinesByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { quantityRemove: number }
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/removeSimultaneousLines`,
      body
    );
  };

  /** Details about simultaneous channels of this line. */
  getLineSimultaneousChannelsDetailsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonySimultaneousChannelsDetails> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/simultaneousChannelsDetails`
    );
  };

  /** Get statistics of the current line */
  getLineStatisticsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyTimestampAndValue> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/line/${serviceName}/statistics`);
  };

  /** Get this object properties */
  getLineTonesByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyTones> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/line/${serviceName}/tones`);
  };

  /** Alter this object properties */
  updateLineTonesByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyTones
  ): Promise<void> => {
    return this.ovh.request('PUT', `/telephony/${billingAccount}/line/${serviceName}/tones`, body);
  };

  /** Upload new tone file */
  postLineTonesToneUploadByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { documentId?: string; type: TelephonyTonesTypeEnum; url?: string }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/tones/toneUpload`,
      body
    );
  };

  /** The traffic extracts (SIP only) of your line */
  getLineTrafficExtractsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/trafficExtracts`
    );
  };

  /** Launch a traffic extract on your line */
  launchLineTrafficExtractsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { dateEnd: Date; dateStart: Date }
  ): Promise<TelephonyTrafficExtract> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/line/${serviceName}/trafficExtracts`,
      body
    );
  };

  /** Delete a traffic extract */
  deleteLineTrafficExtractsByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/line/${serviceName}/trafficExtracts/${id}`
    );
  };

  /** Get this object properties */
  getLineTrafficExtractsByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyTrafficExtract> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/line/${serviceName}/trafficExtracts/${id}`
    );
  };

  /** Unblock the line. It will remove any incoming and outboing block made earlier */
  postLineUnblockByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('POST', `/telephony/${billingAccount}/line/${serviceName}/unblock`);
  };

  /** Miniabx associated with this billing account */
  getMiniPabxByBillingAccount = (billingAccount: string): Promise<string[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/miniPabx`);
  };

  /** Get this object properties */
  getMiniPabxByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyMiniPabx> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/miniPabx/${serviceName}`);
  };

  /** Alter this object properties */
  updateMiniPabxByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyMiniPabx
  ): Promise<void> => {
    return this.ovh.request('PUT', `/telephony/${billingAccount}/miniPabx/${serviceName}`, body);
  };

  /** Get this object properties */
  getMiniPabxHuntingByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyMiniPabxHunting> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/miniPabx/${serviceName}/hunting`);
  };

  /** Alter this object properties */
  updateMiniPabxHuntingByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyMiniPabxHunting
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/miniPabx/${serviceName}/hunting`,
      body
    );
  };

  /** Hunting agents */
  getMiniPabxHuntingAgentByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/miniPabx/${serviceName}/hunting/agent`
    );
  };

  /** Create a new agent */
  createMiniPabxHuntingAgentByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { agentNumber: string; logged: boolean; noReplyTimer: number; position: number }
  ): Promise<TelephonyEasyMiniPabxHuntingAgent> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/miniPabx/${serviceName}/hunting/agent`,
      body
    );
  };

  /** Delete the agent */
  deleteMiniPabxHuntingAgentByBillingAccountAndServiceNameAndAgentNumber = (
    agentNumber: string,
    billingAccount: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/miniPabx/${serviceName}/hunting/agent/${agentNumber}`
    );
  };

  /** Get this object properties */
  getMiniPabxHuntingAgentByBillingAccountAndServiceNameAndAgentNumber = (
    agentNumber: string,
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyEasyMiniPabxHuntingAgent> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/miniPabx/${serviceName}/hunting/agent/${agentNumber}`
    );
  };

  /** Alter this object properties */
  updateMiniPabxHuntingAgentByBillingAccountAndServiceNameAndAgentNumber = (
    agentNumber: string,
    billingAccount: string,
    serviceName: string,
    body: TelephonyEasyMiniPabxHuntingAgent
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/miniPabx/${serviceName}/hunting/agent/${agentNumber}`,
      body
    );
  };

  /** Get this object properties */
  getMiniPabxTonesByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyTones> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/miniPabx/${serviceName}/tones`);
  };

  /** Alter this object properties */
  updateMiniPabxTonesByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyTones
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/miniPabx/${serviceName}/tones`,
      body
    );
  };

  /** Upload new tone file */
  postMiniPabxTonesToneUploadByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { documentId?: string; type: TelephonyTonesTypeEnum; url?: string }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/miniPabx/${serviceName}/tones/toneUpload`,
      body
    );
  };

  /** Additional numbers associated with this billing account */
  addNumberByBillingAccount = (billingAccount: string): Promise<string[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/number`);
  };

  /** Get this object properties */
  getNumberByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyNumber> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/number/${serviceName}`);
  };

  /** Alter this object properties */
  updateNumberByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyNumber
  ): Promise<void> => {
    return this.ovh.request('PUT', `/telephony/${billingAccount}/number/${serviceName}`, body);
  };

  /** Cancel a scheduled conversion to line */
  postNumberCancelConvertToLineByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/number/${serviceName}/cancelConvertToLine`
    );
  };

  /** Change the feature type of the phone number */
  updateNumberFeatureTypeByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { featureType: TelephonyTypeEnum }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/number/${serviceName}/changeFeatureType`,
      body
    );
  };

  /** Schedule a conversion to line */
  postNumberConvertToLineByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { offer: string }
  ): Promise<TelephonyOfferTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/number/${serviceName}/convertToLine`,
      body
    );
  };

  /** Get the available line offers to schedule a conversion to line */
  getNumberConvertToLineAvailableOffersByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyLineOffersAndContracts> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/number/${serviceName}/convertToLineAvailableOffers`
    );
  };

  /** Operations on a telephony service's offer */
  getOfferTaskByBillingAccount = (billingAccount: string): Promise<number[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/offerTask`);
  };

  /** Get this object properties */
  getOfferTaskByBillingAccountAndTaskId = (
    billingAccount: string,
    taskId: number
  ): Promise<TelephonyOfferTask> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/offerTask/${taskId}`);
  };

  /** Alter this object properties */
  updateOfferTaskByBillingAccountAndTaskId = (
    billingAccount: string,
    taskId: number,
    body: TelephonyOfferTask
  ): Promise<void> => {
    return this.ovh.request('PUT', `/telephony/${billingAccount}/offerTask/${taskId}`, body);
  };

  /** List old phones archived as they were not returned after an RMA */
  listOldPhoneByBillingAccount = (billingAccount: string): Promise<TelephonyOldPhone[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/oldPhone`);
  };

  /** Outplan notifications configured for this billing account */
  getOutplanNotificationByBillingAccount = (billingAccount: string): Promise<number[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/outplanNotification`);
  };

  /** Add an outplan notification on the billing account */
  addOutplanNotificationByBillingAccount = (
    billingAccount: string,
    body: { block: TelephonyOutplanNotificationBlockEnum; notifyEmail?: string; percentage: number }
  ): Promise<TelephonyConsumptionThreshold> => {
    return this.ovh.request('POST', `/telephony/${billingAccount}/outplanNotification`, body);
  };

  /** Delete an outplan notification */
  deleteOutplanNotificationByBillingAccountAndId = (
    billingAccount: string,
    id: number
  ): Promise<void> => {
    return this.ovh.request('DELETE', `/telephony/${billingAccount}/outplanNotification/${id}`);
  };

  /** Get this object properties */
  getOutplanNotificationByBillingAccountAndId = (
    billingAccount: string,
    id: number
  ): Promise<TelephonyConsumptionThreshold> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/outplanNotification/${id}`);
  };

  /** OVH calls queues and OVH IVRs (Interactive Voice Response) associated with this billing account */
  getOvhPabxByBillingAccount = (billingAccount: string): Promise<string[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/ovhPabx`);
  };

  /** Get this object properties */
  getOvhPabxByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyOvhPabx> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/ovhPabx/${serviceName}`);
  };

  /** Alter this object properties */
  updateOvhPabxByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyOvhPabx
  ): Promise<void> => {
    return this.ovh.request('PUT', `/telephony/${billingAccount}/ovhPabx/${serviceName}`, body);
  };

  /** Dialplans associated with this PABX */
  getOvhPabxDialplanByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/ovhPabx/${serviceName}/dialplan`);
  };

  /** Create a new dialplan */
  createOvhPabxDialplanByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: {
      anonymousRejection: boolean;
      name: string;
      showCallerNumber: TelephonyOvhPabxDialplanNumberPresentationEnum;
      transferTimeout: number;
    }
  ): Promise<TelephonyOvhPabxDialplan> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/dialplan`,
      body
    );
  };

  /** Delete the given dialplan */
  deleteOvhPabxDialplanByBillingAccountAndServiceNameAndDialplanId = (
    billingAccount: string,
    dialplanId: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/dialplan/${dialplanId}`
    );
  };

  /** Get this object properties */
  getOvhPabxDialplanByBillingAccountAndServiceNameAndDialplanId = (
    billingAccount: string,
    dialplanId: number,
    serviceName: string
  ): Promise<TelephonyOvhPabxDialplan> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/dialplan/${dialplanId}`
    );
  };

  /** Alter this object properties */
  updateOvhPabxDialplanByBillingAccountAndServiceNameAndDialplanId = (
    billingAccount: string,
    dialplanId: number,
    serviceName: string,
    body: TelephonyOvhPabxDialplan
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/dialplan/${dialplanId}`,
      body
    );
  };

  /** Extensions contained in the dialplan */
  getOvhPabxDialplanExtensionByBillingAccountAndServiceNameAndDialplanId = (
    billingAccount: string,
    dialplanId: number,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/dialplan/${dialplanId}/extension`
    );
  };

  /** Create a new extension for a dialplan */
  createOvhPabxDialplanExtensionByBillingAccountAndServiceNameAndDialplanId = (
    billingAccount: string,
    dialplanId: number,
    serviceName: string,
    body: {
      enable: boolean;
      position: number;
      schedulerCategory?: TelephonySchedulerCategoryEnum;
      screenListType?: TelephonyOvhPabxDialplanExtensionConditionScreenListTypeEnum;
    }
  ): Promise<TelephonyOvhPabxDialplanExtension> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/dialplan/${dialplanId}/extension`,
      body
    );
  };

  /** Delete the given extension */
  deleteOvhPabxDialplanExtensionByBillingAccountAndServiceNameAndDialplanIdAndExtensionId = (
    billingAccount: string,
    dialplanId: number,
    extensionId: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/dialplan/${dialplanId}/extension/${extensionId}`
    );
  };

  /** Get this object properties */
  getOvhPabxDialplanExtensionByBillingAccountAndServiceNameAndDialplanIdAndExtensionId = (
    billingAccount: string,
    dialplanId: number,
    extensionId: number,
    serviceName: string
  ): Promise<TelephonyOvhPabxDialplanExtension> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/dialplan/${dialplanId}/extension/${extensionId}`
    );
  };

  /** Alter this object properties */
  updateOvhPabxDialplanExtensionByBillingAccountAndServiceNameAndDialplanIdAndExtensionId = (
    billingAccount: string,
    dialplanId: number,
    extensionId: number,
    serviceName: string,
    body: TelephonyOvhPabxDialplanExtension
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/dialplan/${dialplanId}/extension/${extensionId}`,
      body
    );
  };

  /** Screenlist conditions checked when executing the extension */
  getOvhPabxDialplanExtensionConditionScreenListByBillingAccountAndServiceNameAndDialplanIdAndExtensionId =
    (
      billingAccount: string,
      dialplanId: number,
      extensionId: number,
      serviceName: string
    ): Promise<number[]> => {
      return this.ovh.request(
        'GET',
        `/telephony/${billingAccount}/ovhPabx/${serviceName}/dialplan/${dialplanId}/extension/${extensionId}/conditionScreenList`
      );
    };

  /** Create a new screenlist condition for an extension */
  createOvhPabxDialplanExtensionConditionScreenListByBillingAccountAndServiceNameAndDialplanIdAndExtensionId =
    (
      billingAccount: string,
      dialplanId: number,
      extensionId: number,
      serviceName: string,
      body: {
        callerIdNumber?: string;
        destinationNumber?: string;
        screenListType?: TelephonyOvhPabxDialplanExtensionConditionScreenListTypeEnum;
      }
    ): Promise<TelephonyOvhPabxDialplanExtensionConditionScreenList> => {
      return this.ovh.request(
        'POST',
        `/telephony/${billingAccount}/ovhPabx/${serviceName}/dialplan/${dialplanId}/extension/${extensionId}/conditionScreenList`,
        body
      );
    };

  /** Delete the given condition */
  deleteOvhPabxDialplanExtensionConditionScreenListByBillingAccountAndServiceNameAndDialplanIdAndExtensionIdAndConditionId =
    (
      billingAccount: string,
      conditionId: number,
      dialplanId: number,
      extensionId: number,
      serviceName: string
    ): Promise<void> => {
      return this.ovh.request(
        'DELETE',
        `/telephony/${billingAccount}/ovhPabx/${serviceName}/dialplan/${dialplanId}/extension/${extensionId}/conditionScreenList/${conditionId}`
      );
    };

  /** Get this object properties */
  getOvhPabxDialplanExtensionConditionScreenListByBillingAccountAndServiceNameAndDialplanIdAndExtensionIdAndConditionId =
    (
      billingAccount: string,
      conditionId: number,
      dialplanId: number,
      extensionId: number,
      serviceName: string
    ): Promise<TelephonyOvhPabxDialplanExtensionConditionScreenList> => {
      return this.ovh.request(
        'GET',
        `/telephony/${billingAccount}/ovhPabx/${serviceName}/dialplan/${dialplanId}/extension/${extensionId}/conditionScreenList/${conditionId}`
      );
    };

  /** Time conditions checked when executing the extension */
  getOvhPabxDialplanExtensionConditionTimeByBillingAccountAndServiceNameAndDialplanIdAndExtensionId =
    (
      billingAccount: string,
      dialplanId: number,
      extensionId: number,
      serviceName: string
    ): Promise<number[]> => {
      return this.ovh.request(
        'GET',
        `/telephony/${billingAccount}/ovhPabx/${serviceName}/dialplan/${dialplanId}/extension/${extensionId}/conditionTime`
      );
    };

  /** Create a new time condition for an extension */
  createOvhPabxDialplanExtensionConditionTimeByBillingAccountAndServiceNameAndDialplanIdAndExtensionId =
    (
      billingAccount: string,
      dialplanId: number,
      extensionId: number,
      serviceName: string,
      body: {
        timeFrom: Date;
        timeTo: Date;
        weekDay: TelephonyOvhPabxDialplanExtensionConditionTimeWeekDayEnum;
      }
    ): Promise<TelephonyOvhPabxDialplanExtensionConditionTime> => {
      return this.ovh.request(
        'POST',
        `/telephony/${billingAccount}/ovhPabx/${serviceName}/dialplan/${dialplanId}/extension/${extensionId}/conditionTime`,
        body
      );
    };

  /** Delete the given condition */
  deleteOvhPabxDialplanExtensionConditionTimeByBillingAccountAndServiceNameAndDialplanIdAndExtensionIdAndConditionId =
    (
      billingAccount: string,
      conditionId: number,
      dialplanId: number,
      extensionId: number,
      serviceName: string
    ): Promise<void> => {
      return this.ovh.request(
        'DELETE',
        `/telephony/${billingAccount}/ovhPabx/${serviceName}/dialplan/${dialplanId}/extension/${extensionId}/conditionTime/${conditionId}`
      );
    };

  /** Get this object properties */
  getOvhPabxDialplanExtensionConditionTimeByBillingAccountAndServiceNameAndDialplanIdAndExtensionIdAndConditionId =
    (
      billingAccount: string,
      conditionId: number,
      dialplanId: number,
      extensionId: number,
      serviceName: string
    ): Promise<TelephonyOvhPabxDialplanExtensionConditionTime> => {
      return this.ovh.request(
        'GET',
        `/telephony/${billingAccount}/ovhPabx/${serviceName}/dialplan/${dialplanId}/extension/${extensionId}/conditionTime/${conditionId}`
      );
    };

  /** Alter this object properties */
  updateOvhPabxDialplanExtensionConditionTimeByBillingAccountAndServiceNameAndDialplanIdAndExtensionIdAndConditionId =
    (
      billingAccount: string,
      conditionId: number,
      dialplanId: number,
      extensionId: number,
      serviceName: string,
      body: TelephonyOvhPabxDialplanExtensionConditionTime
    ): Promise<void> => {
      return this.ovh.request(
        'PUT',
        `/telephony/${billingAccount}/ovhPabx/${serviceName}/dialplan/${dialplanId}/extension/${extensionId}/conditionTime/${conditionId}`,
        body
      );
    };

  /** Rules contained in the extension */
  getOvhPabxDialplanExtensionRuleByBillingAccountAndServiceNameAndDialplanIdAndExtensionId = (
    billingAccount: string,
    dialplanId: number,
    extensionId: number,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/dialplan/${dialplanId}/extension/${extensionId}/rule`
    );
  };

  /** Create a new rule for an extension */
  createOvhPabxDialplanExtensionRuleByBillingAccountAndServiceNameAndDialplanIdAndExtensionId = (
    billingAccount: string,
    dialplanId: number,
    extensionId: number,
    serviceName: string,
    body: {
      action: TelephonyOvhPabxDialplanExtensionRuleActionEnum;
      actionParam?: string;
      negativeAction: boolean;
      position: number;
    }
  ): Promise<TelephonyOvhPabxDialplanExtensionRule> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/dialplan/${dialplanId}/extension/${extensionId}/rule`,
      body
    );
  };

  /** Delete the given rule */
  deleteOvhPabxDialplanExtensionRuleByBillingAccountAndServiceNameAndDialplanIdAndExtensionIdAndRuleId =
    (
      billingAccount: string,
      dialplanId: number,
      extensionId: number,
      ruleId: number,
      serviceName: string
    ): Promise<void> => {
      return this.ovh.request(
        'DELETE',
        `/telephony/${billingAccount}/ovhPabx/${serviceName}/dialplan/${dialplanId}/extension/${extensionId}/rule/${ruleId}`
      );
    };

  /** Get this object properties */
  getOvhPabxDialplanExtensionRuleByBillingAccountAndServiceNameAndDialplanIdAndExtensionIdAndRuleId =
    (
      billingAccount: string,
      dialplanId: number,
      extensionId: number,
      ruleId: number,
      serviceName: string
    ): Promise<TelephonyOvhPabxDialplanExtensionRule> => {
      return this.ovh.request(
        'GET',
        `/telephony/${billingAccount}/ovhPabx/${serviceName}/dialplan/${dialplanId}/extension/${extensionId}/rule/${ruleId}`
      );
    };

  /** Alter this object properties */
  updateOvhPabxDialplanExtensionRuleByBillingAccountAndServiceNameAndDialplanIdAndExtensionIdAndRuleId =
    (
      billingAccount: string,
      dialplanId: number,
      extensionId: number,
      ruleId: number,
      serviceName: string,
      body: TelephonyOvhPabxDialplanExtensionRule
    ): Promise<void> => {
      return this.ovh.request(
        'PUT',
        `/telephony/${billingAccount}/ovhPabx/${serviceName}/dialplan/${dialplanId}/extension/${extensionId}/rule/${ruleId}`,
        body
      );
    };

  /** Get this object properties */
  getOvhPabxHuntingByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyOvhPabxHunting> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting`);
  };

  /** Alter this object properties */
  updateOvhPabxHuntingByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyOvhPabxHunting
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting`,
      body
    );
  };

  /** Calls agents */
  getOvhPabxHuntingAgentByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/agent`
    );
  };

  /** Create a new agent */
  createOvhPabxHuntingAgentByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: {
      description?: string;
      number: string;
      simultaneousLines: number;
      status: TelephonyOvhPabxHuntingAgentStatusEnum;
      timeout: number;
      wrapUpTime: number;
    }
  ): Promise<TelephonyOvhPabxHuntingAgent> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/agent`,
      body
    );
  };

  /** Delete the given agent */
  deleteOvhPabxHuntingAgentByBillingAccountAndServiceNameAndAgentId = (
    agentId: number,
    billingAccount: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/agent/${agentId}`
    );
  };

  /** Get this object properties */
  getOvhPabxHuntingAgentByBillingAccountAndServiceNameAndAgentId = (
    agentId: number,
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyOvhPabxHuntingAgent> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/agent/${agentId}`
    );
  };

  /** Alter this object properties */
  updateOvhPabxHuntingAgentByBillingAccountAndServiceNameAndAgentId = (
    agentId: number,
    billingAccount: string,
    serviceName: string,
    body: TelephonyOvhPabxHuntingAgent
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/agent/${agentId}`,
      body
    );
  };

  /** Delete the given web access */
  deleteOvhPabxHuntingAgentBannerAccessByBillingAccountAndServiceNameAndAgentId = (
    agentId: number,
    billingAccount: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/agent/${agentId}/bannerAccess`
    );
  };

  /** Get this object properties */
  getOvhPabxHuntingAgentBannerAccessByBillingAccountAndServiceNameAndAgentId = (
    agentId: number,
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyBannerAccess> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/agent/${agentId}/bannerAccess`
    );
  };

  /** Create a new web access for this ressource */
  createOvhPabxHuntingAgentBannerAccessByBillingAccountAndServiceNameAndAgentId = (
    agentId: number,
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyBannerAccess> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/agent/${agentId}/bannerAccess`
    );
  };

  /** Current calls of the callcenter agent */
  getOvhPabxHuntingAgentCallsByBillingAccountAndServiceNameAndAgentId = (
    agentId: number,
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/agent/${agentId}/calls`
    );
  };

  /** Get this object properties */
  getOvhPabxHuntingAgentCallsByBillingAccountAndServiceNameAndAgentIdAndId = (
    agentId: number,
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyOvhPabxHuntingQueueLiveCalls> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/agent/${agentId}/calls/${id}`
    );
  };

  /** Eavesdrop on a call */
  postOvhPabxHuntingAgentCallsEavesdropByBillingAccountAndServiceNameAndAgentIdAndId = (
    agentId: number,
    billingAccount: string,
    id: number,
    serviceName: string,
    body: { number: string }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/agent/${agentId}/calls/${id}/eavesdrop`,
      body
    );
  };

  /** Hangup a call */
  postOvhPabxHuntingAgentCallsHangupByBillingAccountAndServiceNameAndAgentIdAndId = (
    agentId: number,
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/agent/${agentId}/calls/${id}/hangup`
    );
  };

  /** Toogle hold on call */
  postOvhPabxHuntingAgentCallsHoldByBillingAccountAndServiceNameAndAgentIdAndId = (
    agentId: number,
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/agent/${agentId}/calls/${id}/hold`
    );
  };

  /** Intercept a non answered call */
  postOvhPabxHuntingAgentCallsInterceptByBillingAccountAndServiceNameAndAgentIdAndId = (
    agentId: number,
    billingAccount: string,
    id: number,
    serviceName: string,
    body: { number: string }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/agent/${agentId}/calls/${id}/intercept`,
      body
    );
  };

  /** Transfer an answered call */
  postOvhPabxHuntingAgentCallsTransferByBillingAccountAndServiceNameAndAgentIdAndId = (
    agentId: number,
    billingAccount: string,
    id: number,
    serviceName: string,
    body: { number: string }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/agent/${agentId}/calls/${id}/transfer`,
      body
    );
  };

  /** Whisper on a call */
  postOvhPabxHuntingAgentCallsWhisperByBillingAccountAndServiceNameAndAgentIdAndId = (
    agentId: number,
    billingAccount: string,
    id: number,
    serviceName: string,
    body: { number: string; whisperingMode: TelephonyOvhPabxWhisperingModeEnum }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/agent/${agentId}/calls/${id}/whisper`,
      body
    );
  };

  /** Delete the given token */
  deleteOvhPabxHuntingAgentEventTokenByBillingAccountAndServiceNameAndAgentId = (
    agentId: number,
    billingAccount: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/agent/${agentId}/eventToken`
    );
  };

  /** Get this object properties */
  getOvhPabxHuntingAgentEventTokenByBillingAccountAndServiceNameAndAgentId = (
    agentId: number,
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyEventToken> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/agent/${agentId}/eventToken`
    );
  };

  /** Create a new token */
  createOvhPabxHuntingAgentEventTokenByBillingAccountAndServiceNameAndAgentId = (
    agentId: number,
    billingAccount: string,
    serviceName: string,
    body: { expiration: TelephonyTokenExpirationEnum }
  ): Promise<string> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/agent/${agentId}/eventToken`,
      body
    );
  };

  /** Get this object properties */
  getOvhPabxHuntingAgentLiveStatusByBillingAccountAndServiceNameAndAgentId = (
    agentId: number,
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyOvhPabxHuntingAgentLiveStatus> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/agent/${agentId}/liveStatus`
    );
  };

  /** Agent assigned to the queues */
  getOvhPabxHuntingAgentQueueByBillingAccountAndServiceNameAndAgentId = (
    agentId: number,
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/agent/${agentId}/queue`
    );
  };

  /** Create a new skill for an agent (it adds the agent in a queue) */
  createOvhPabxHuntingAgentQueueByBillingAccountAndServiceNameAndAgentId = (
    agentId: number,
    billingAccount: string,
    serviceName: string,
    body: { position: number; queueId: number }
  ): Promise<TelephonyOvhPabxHuntingAgentQueue> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/agent/${agentId}/queue`,
      body
    );
  };

  /** Delete the given skill */
  deleteOvhPabxHuntingAgentQueueByBillingAccountAndServiceNameAndAgentIdAndQueueId = (
    agentId: number,
    billingAccount: string,
    queueId: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/agent/${agentId}/queue/${queueId}`
    );
  };

  /** Get this object properties */
  getOvhPabxHuntingAgentQueueByBillingAccountAndServiceNameAndAgentIdAndQueueId = (
    agentId: number,
    billingAccount: string,
    queueId: number,
    serviceName: string
  ): Promise<TelephonyOvhPabxHuntingAgentQueue> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/agent/${agentId}/queue/${queueId}`
    );
  };

  /** Alter this object properties */
  updateOvhPabxHuntingAgentQueueByBillingAccountAndServiceNameAndAgentIdAndQueueId = (
    agentId: number,
    billingAccount: string,
    queueId: number,
    serviceName: string,
    body: TelephonyOvhPabxHuntingAgentQueue
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/agent/${agentId}/queue/${queueId}`,
      body
    );
  };

  /** Get this object properties */
  getOvhPabxHuntingAgentQueueLiveStatusByBillingAccountAndServiceNameAndAgentIdAndQueueId = (
    agentId: number,
    billingAccount: string,
    queueId: number,
    serviceName: string
  ): Promise<TelephonyOvhPabxHuntingAgentLiveStatus> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/agent/${agentId}/queue/${queueId}/liveStatus`
    );
  };

  /** Custom statuses of your agents */
  getOvhPabxHuntingCustomStatusByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/customStatus`
    );
  };

  /** Create a new custom status */
  createOvhPabxHuntingCustomStatusByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { color?: string; description?: string; name: string }
  ): Promise<TelephonyOvhPabxCustomStatus> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/customStatus`,
      body
    );
  };

  /** Delete the given custom status */
  deleteOvhPabxHuntingCustomStatusByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/customStatus/${id}`
    );
  };

  /** Get this object properties */
  getOvhPabxHuntingCustomStatusByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyOvhPabxCustomStatus> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/customStatus/${id}`
    );
  };

  /** Delete the given token */
  deleteOvhPabxHuntingEventTokenByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/eventToken`
    );
  };

  /** Get this object properties */
  getOvhPabxHuntingEventTokenByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyEventToken> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/eventToken`
    );
  };

  /** Create a new token */
  createOvhPabxHuntingEventTokenByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { expiration: TelephonyTokenExpirationEnum }
  ): Promise<string> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/eventToken`,
      body
    );
  };

  /** Calls queues */
  getOvhPabxHuntingQueueByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/queue`
    );
  };

  /** Create a new queue */
  createOvhPabxHuntingQueueByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: {
      actionOnClosure?: TelephonyOvhPabxQueueActionEnum;
      actionOnClosureParam?: string;
      actionOnOverflow?: TelephonyOvhPabxQueueActionEnum;
      actionOnOverflowParam?: string;
      askForRecordDisabling?: boolean;
      description?: string;
      maxMember?: number;
      maxWaitTime?: number;
      record?: boolean;
      recordDisablingDigit?: TelephonyOvhPabxHuntingQueueRecordDisablingDigitEnum;
      recordDisablingLanguage?: TelephonyOvhPabxHuntingQueueRecordDisablingLanguageEnum;
      soundOnHold?: number;
      strategy: TelephonyOvhPabxHuntingQueueStrategyEnum;
    }
  ): Promise<TelephonyOvhPabxHuntingQueue> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/queue`,
      body
    );
  };

  /** Delete the given queue */
  deleteOvhPabxHuntingQueueByBillingAccountAndServiceNameAndQueueId = (
    billingAccount: string,
    queueId: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/queue/${queueId}`
    );
  };

  /** Get this object properties */
  getOvhPabxHuntingQueueByBillingAccountAndServiceNameAndQueueId = (
    billingAccount: string,
    queueId: number,
    serviceName: string
  ): Promise<TelephonyOvhPabxHuntingQueue> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/queue/${queueId}`
    );
  };

  /** Alter this object properties */
  updateOvhPabxHuntingQueueByBillingAccountAndServiceNameAndQueueId = (
    billingAccount: string,
    queueId: number,
    serviceName: string,
    body: TelephonyOvhPabxHuntingQueue
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/queue/${queueId}`,
      body
    );
  };

  /** Agent assigned to the queue */
  getOvhPabxHuntingQueueAgentByBillingAccountAndServiceNameAndQueueId = (
    billingAccount: string,
    queueId: number,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/queue/${queueId}/agent`
    );
  };

  /** Create a new skill for an agent (it adds the agent in a queue) */
  createOvhPabxHuntingQueueAgentByBillingAccountAndServiceNameAndQueueId = (
    billingAccount: string,
    serviceName: string,
    body: { position: number; queueId: number }
  ): Promise<TelephonyOvhPabxHuntingAgentQueue> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/queue/${body.queueId}/agent`,
      body
    );
  };

  /** Delete the given skill */
  deleteOvhPabxHuntingQueueAgentByBillingAccountAndServiceNameAndQueueIdAndAgentId = (
    agentId: number,
    billingAccount: string,
    queueId: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/queue/${queueId}/agent/${agentId}`
    );
  };

  /** Get this object properties */
  getOvhPabxHuntingQueueAgentByBillingAccountAndServiceNameAndQueueIdAndAgentId = (
    agentId: number,
    billingAccount: string,
    queueId: number,
    serviceName: string
  ): Promise<TelephonyOvhPabxHuntingAgentQueue> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/queue/${queueId}/agent/${agentId}`
    );
  };

  /** Alter this object properties */
  updateOvhPabxHuntingQueueAgentByBillingAccountAndServiceNameAndQueueIdAndAgentId = (
    agentId: number,
    billingAccount: string,
    queueId: number,
    serviceName: string,
    body: TelephonyOvhPabxHuntingAgentQueue
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/queue/${queueId}/agent/${agentId}`,
      body
    );
  };

  /** Get this object properties */
  getOvhPabxHuntingQueueAgentLiveStatusByBillingAccountAndServiceNameAndQueueIdAndAgentId = (
    agentId: number,
    billingAccount: string,
    queueId: number,
    serviceName: string
  ): Promise<TelephonyOvhPabxHuntingAgentLiveStatus> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/queue/${queueId}/agent/${agentId}/liveStatus`
    );
  };

  /** Live calls of the queue */
  getOvhPabxHuntingQueueLiveCallsByBillingAccountAndServiceNameAndQueueId = (
    billingAccount: string,
    queueId: number,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/queue/${queueId}/liveCalls`
    );
  };

  /** Get this object properties */
  getOvhPabxHuntingQueueLiveCallsByBillingAccountAndServiceNameAndQueueIdAndId = (
    billingAccount: string,
    id: number,
    queueId: number,
    serviceName: string
  ): Promise<TelephonyOvhPabxHuntingQueueLiveCalls> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/queue/${queueId}/liveCalls/${id}`
    );
  };

  /** Eavesdrop on a call */
  postOvhPabxHuntingQueueLiveCallsEavesdropByBillingAccountAndServiceNameAndQueueIdAndId = (
    billingAccount: string,
    id: number,
    queueId: number,
    serviceName: string,
    body: { number: string }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/queue/${queueId}/liveCalls/${id}/eavesdrop`,
      body
    );
  };

  /** Hangup a call */
  postOvhPabxHuntingQueueLiveCallsHangupByBillingAccountAndServiceNameAndQueueIdAndId = (
    billingAccount: string,
    id: number,
    queueId: number,
    serviceName: string
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/queue/${queueId}/liveCalls/${id}/hangup`
    );
  };

  /** Toogle hold on call */
  postOvhPabxHuntingQueueLiveCallsHoldByBillingAccountAndServiceNameAndQueueIdAndId = (
    billingAccount: string,
    id: number,
    queueId: number,
    serviceName: string
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/queue/${queueId}/liveCalls/${id}/hold`
    );
  };

  /** Intercept a non answered call */
  postOvhPabxHuntingQueueLiveCallsInterceptByBillingAccountAndServiceNameAndQueueIdAndId = (
    billingAccount: string,
    id: number,
    queueId: number,
    serviceName: string,
    body: { number: string }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/queue/${queueId}/liveCalls/${id}/intercept`,
      body
    );
  };

  /** Transfer an answered call */
  postOvhPabxHuntingQueueLiveCallsTransferByBillingAccountAndServiceNameAndQueueIdAndId = (
    billingAccount: string,
    id: number,
    queueId: number,
    serviceName: string,
    body: { number: string }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/queue/${queueId}/liveCalls/${id}/transfer`,
      body
    );
  };

  /** Whisper on a call */
  postOvhPabxHuntingQueueLiveCallsWhisperByBillingAccountAndServiceNameAndQueueIdAndId = (
    billingAccount: string,
    id: number,
    queueId: number,
    serviceName: string,
    body: { number: string; whisperingMode: TelephonyOvhPabxWhisperingModeEnum }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/queue/${queueId}/liveCalls/${id}/whisper`,
      body
    );
  };

  /** Get this object properties */
  getOvhPabxHuntingQueueLiveStatisticsByBillingAccountAndServiceNameAndQueueId = (
    billingAccount: string,
    queueId: number,
    serviceName: string
  ): Promise<TelephonyOvhPabxHuntingQueueLiveStatistics> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/hunting/queue/${queueId}/liveStatistics`
    );
  };

  /** Menus associated with this PABX */
  getOvhPabxMenuByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/ovhPabx/${serviceName}/menu`);
  };

  /** Create a new menu */
  createOvhPabxMenuByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: {
      greetSound?: number;
      greetSoundTts?: number;
      interDigitTimeout?: number;
      invalidSound?: number;
      invalidSoundTts?: number;
      name: string;
      timeout?: number;
    }
  ): Promise<TelephonyOvhPabxMenu> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/menu`,
      body
    );
  };

  /** Delete the given menu */
  deleteOvhPabxMenuByBillingAccountAndServiceNameAndMenuId = (
    billingAccount: string,
    menuId: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/menu/${menuId}`
    );
  };

  /** Get this object properties */
  getOvhPabxMenuByBillingAccountAndServiceNameAndMenuId = (
    billingAccount: string,
    menuId: number,
    serviceName: string
  ): Promise<TelephonyOvhPabxMenu> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/menu/${menuId}`
    );
  };

  /** Alter this object properties */
  updateOvhPabxMenuByBillingAccountAndServiceNameAndMenuId = (
    billingAccount: string,
    menuId: number,
    serviceName: string,
    body: TelephonyOvhPabxMenu
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/menu/${menuId}`,
      body
    );
  };

  /** Menu entry */
  getOvhPabxMenuEntryByBillingAccountAndServiceNameAndMenuId = (
    billingAccount: string,
    menuId: number,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/menu/${menuId}/entry`
    );
  };

  /** Create a new menu entry */
  createOvhPabxMenuEntryByBillingAccountAndServiceNameAndMenuId = (
    billingAccount: string,
    menuId: number,
    serviceName: string,
    body: {
      action: TelephonyOvhPabxIvrMenuEntryActionEnum;
      actionParam?: string;
      dtmf: string;
      position: number;
    }
  ): Promise<TelephonyOvhPabxMenuEntry> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/menu/${menuId}/entry`,
      body
    );
  };

  /** Delete the given menu entry */
  deleteOvhPabxMenuEntryByBillingAccountAndServiceNameAndMenuIdAndEntryId = (
    billingAccount: string,
    entryId: number,
    menuId: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/menu/${menuId}/entry/${entryId}`
    );
  };

  /** Get this object properties */
  getOvhPabxMenuEntryByBillingAccountAndServiceNameAndMenuIdAndEntryId = (
    billingAccount: string,
    entryId: number,
    menuId: number,
    serviceName: string
  ): Promise<TelephonyOvhPabxMenuEntry> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/menu/${menuId}/entry/${entryId}`
    );
  };

  /** Alter this object properties */
  updateOvhPabxMenuEntryByBillingAccountAndServiceNameAndMenuIdAndEntryId = (
    billingAccount: string,
    entryId: number,
    menuId: number,
    serviceName: string,
    body: TelephonyOvhPabxMenuEntry
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/menu/${menuId}/entry/${entryId}`,
      body
    );
  };

  /** Records associated with this PABX */
  getOvhPabxRecordsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/ovhPabx/${serviceName}/records`);
  };

  /** Delete the given record */
  deleteOvhPabxRecordsByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/records/${id}`
    );
  };

  /** Get this object properties */
  getOvhPabxRecordsByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyOvhPabxRecord> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/records/${id}`
    );
  };

  /** Sounds associated with this PABX */
  getOvhPabxSoundByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/ovhPabx/${serviceName}/sound`);
  };

  /** Delete the given sound */
  deleteOvhPabxSoundByBillingAccountAndServiceNameAndSoundId = (
    billingAccount: string,
    serviceName: string,
    soundId: number
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/sound/${soundId}`
    );
  };

  /** Get this object properties */
  getOvhPabxSoundByBillingAccountAndServiceNameAndSoundId = (
    billingAccount: string,
    serviceName: string,
    soundId: number
  ): Promise<TelephonyOvhPabxSound> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/sound/${soundId}`
    );
  };

  /** Upload new sound file */
  postOvhPabxSoundUploadByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { documentId?: string; name?: string; url?: string }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/soundUpload`,
      body
    );
  };

  /** Text to Speech associated with this PABX */
  getOvhPabxTtsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/ovhPabx/${serviceName}/tts`);
  };

  /** Create a new text to speech */
  createOvhPabxTtsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { text: string; voice?: TelephonyOvhPabxTtsVoiceEnum }
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/tts`,
      body
    );
  };

  /** Delete the given text to speech */
  deleteOvhPabxTtsByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/tts/${id}`
    );
  };

  /** Get this object properties */
  getOvhPabxTtsByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyOvhPabxTts> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/ovhPabx/${serviceName}/tts/${id}`);
  };

  /** Alter this object properties */
  updateOvhPabxTtsByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string,
    body: TelephonyOvhPabxTts
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/ovhPabx/${serviceName}/tts/${id}`,
      body
    );
  };

  /** Return phonebooks associated to this group */
  getPhonebookByBillingAccount = (billingAccount: string): Promise<string[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/phonebook`);
  };

  /** Add a phonebook on group. Return the bookKey. */
  addPhonebookByBillingAccount = (
    billingAccount: string,
    body: { name: string }
  ): Promise<string> => {
    return this.ovh.request('POST', `/telephony/${billingAccount}/phonebook`, body);
  };

  /** Delete a phonebook */
  deletePhonebookByBillingAccountAndBookKey = (
    billingAccount: string,
    bookKey: string
  ): Promise<void> => {
    return this.ovh.request('DELETE', `/telephony/${billingAccount}/phonebook/${bookKey}`);
  };

  /** Get this object properties */
  getPhonebookByBillingAccountAndBookKey = (
    billingAccount: string,
    bookKey: string
  ): Promise<TelephonyPhonebookMaster> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/phonebook/${bookKey}`);
  };

  /** Alter this object properties */
  updatePhonebookByBillingAccountAndBookKey = (
    billingAccount: string,
    bookKey: string,
    body: TelephonyPhonebookMaster
  ): Promise<void> => {
    return this.ovh.request('PUT', `/telephony/${billingAccount}/phonebook/${bookKey}`, body);
  };

  /** Export the phonebook's contacts */
  exportPhonebookByBillingAccountAndBookKey = (
    billingAccount: string,
    bookKey: string
  ): Promise<TelephonyPcsFile> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/phonebook/${bookKey}/export`);
  };

  /** Import a contacts file. Supported formats are Excel (.xls and .xlsx) and CSV */
  postPhonebookImportByBillingAccountAndBookKey = (
    billingAccount: string,
    bookKey: string,
    body: { documentId: string }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/phonebook/${bookKey}/import`,
      body
    );
  };

  /** Phonebook contacts */
  getPhonebookPhonebookContactByBillingAccountAndBookKey = (
    billingAccount: string,
    bookKey: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/phonebook/${bookKey}/phonebookContact`
    );
  };

  /** Create a phonebook contact. Return identifier of the phonebook contact. */
  createPhonebookPhonebookContactByBillingAccountAndBookKey = (
    billingAccount: string,
    bookKey: string,
    body: {
      group: string;
      homeMobile?: string;
      homePhone?: string;
      name: string;
      surname: string;
      workMobile?: string;
      workPhone?: string;
    }
  ): Promise<number> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/phonebook/${bookKey}/phonebookContact`,
      body
    );
  };

  /** Delete a phonebook contact */
  deletePhonebookPhonebookContactByBillingAccountAndBookKeyAndId = (
    billingAccount: string,
    bookKey: string,
    id: number
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/phonebook/${bookKey}/phonebookContact/${id}`
    );
  };

  /** Get this object properties */
  getPhonebookPhonebookContactByBillingAccountAndBookKeyAndId = (
    billingAccount: string,
    bookKey: string,
    id: number
  ): Promise<TelephonyPhonebookContact> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/phonebook/${bookKey}/phonebookContact/${id}`
    );
  };

  /** Alter this object properties */
  updatePhonebookPhonebookContactByBillingAccountAndBookKeyAndId = (
    billingAccount: string,
    bookKey: string,
    id: number,
    body: TelephonyPhonebookContact
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/phonebook/${bookKey}/phonebookContact/${id}`,
      body
    );
  };

  /** Current number portabilities for this billing account */
  getPortabilityByBillingAccount = (billingAccount: string): Promise<number[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/portability`);
  };

  /** Get this object properties */
  getPortabilityByBillingAccountAndId = (
    billingAccount: string,
    id: number
  ): Promise<TelephonyPortability> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/portability/${id}`);
  };

  /** Indicates whether or not the portability can be cancelled */
  getPortabilityCanBeCancelledByBillingAccountAndId = (
    billingAccount: string,
    id: number
  ): Promise<boolean> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/portability/${id}/canBeCancelled`);
  };

  /** Indicates whether or not the portability can be executed */
  getPortabilityCanBeExecutedByBillingAccountAndId = (
    billingAccount: string,
    id: number
  ): Promise<boolean> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/portability/${id}/canBeExecuted`);
  };

  /** Ask to cancel the portability */
  postPortabilityCancelByBillingAccountAndId = (
    billingAccount: string,
    id: number,
    body: { reason?: string }
  ): Promise<void> => {
    return this.ovh.request('POST', `/telephony/${billingAccount}/portability/${id}/cancel`, body);
  };

  /** Ask to change the portability date */
  postPortabilityChangeDateByBillingAccountAndId = (
    billingAccount: string,
    id: number,
    body: { date: Date }
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/portability/${id}/changeDate`,
      body
    );
  };

  /** Indicates whether or not the portability date can be changed */
  getPortabilityDateCanBeChangedByBillingAccountAndId = (
    billingAccount: string,
    id: number
  ): Promise<boolean> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/portability/${id}/dateCanBeChanged`
    );
  };

  /** Document linked to this portability */
  getPortabilityDocumentByBillingAccountAndId = (
    billingAccount: string,
    id: number
  ): Promise<number[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/portability/${id}/document`);
  };

  /** Create a portability document */
  createPortabilityDocumentByBillingAccountAndId = (
    billingAccount: string,
    id: number,
    body: { description?: string; name: string }
  ): Promise<TelephonyPortabilityDocument> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/portability/${id}/document`,
      body
    );
  };

  /** Delete the document */
  deletePortabilityDocumentByBillingAccountAndIdAndDocumentId = (
    billingAccount: string,
    documentId: number,
    id: number
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/portability/${id}/document/${documentId}`
    );
  };

  /** Get this object properties */
  getPortabilityDocumentByBillingAccountAndIdAndDocumentId = (
    billingAccount: string,
    documentId: number,
    id: number
  ): Promise<TelephonyPortabilityDocument> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/portability/${id}/document/${documentId}`
    );
  };

  /** Alter this object properties */
  updatePortabilityDocumentByBillingAccountAndIdAndDocumentId = (
    billingAccount: string,
    documentId: number,
    id: number,
    body: TelephonyPortabilityDocument
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/portability/${id}/document/${documentId}`,
      body
    );
  };

  /** Ask to execute the portability */
  postPortabilityExecuteByBillingAccountAndId = (
    billingAccount: string,
    id: number
  ): Promise<void> => {
    return this.ovh.request('POST', `/telephony/${billingAccount}/portability/${id}/execute`);
  };

  /** Indicates whether or not error can be fixed and portability can be relaunched */
  getPortabilityRelaunchByBillingAccountAndId = (
    billingAccount: string,
    id: number
  ): Promise<TelephonyPortabilityFixErrorPossibleParameters> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/portability/${id}/relaunch`);
  };

  /** Fix error and relaunch portability */
  postPortabilityRelaunchByBillingAccountAndId = (
    billingAccount: string,
    id: number,
    body: { parameters: string }
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/portability/${id}/relaunch`,
      body
    );
  };

  /** Indicates the current status of the portability, with a list of steps */
  getPortabilityStatusByBillingAccountAndId = (
    billingAccount: string,
    id: number
  ): Promise<TelephonyPortabilityStep[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/portability/${id}/status`);
  };

  /** Redirects associated with this billing account */
  getRedirectByBillingAccount = (billingAccount: string): Promise<string[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/redirect`);
  };

  /** Get this object properties */
  getRedirectByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyRedirect> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/redirect/${serviceName}`);
  };

  /** Alter this object properties */
  updateRedirectByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyRedirect
  ): Promise<void> => {
    return this.ovh.request('PUT', `/telephony/${billingAccount}/redirect/${serviceName}`, body);
  };

  /** Change the destination of the redirect */
  updateRedirectDestinationByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { destination: string }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/redirect/${serviceName}/changeDestination`,
      body
    );
  };

  /** Service concerned by the french RSVA reform */
  getRsvaByBillingAccount = (billingAccount: string): Promise<string[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/rsva`);
  };

  /** Get this object properties */
  getRsvaByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyRsva> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/rsva/${serviceName}`);
  };

  /** Alter this object properties */
  updateRsvaByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyRsva
  ): Promise<void> => {
    return this.ovh.request('PUT', `/telephony/${billingAccount}/rsva/${serviceName}`, body);
  };

  /** Compatible rate codes related to this value added service */
  getRsvaAllowedRateCodesByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyRateCodeInformation[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/rsva/${serviceName}/allowedRateCodes`
    );
  };

  /** Cancel a scheduled rate code update */
  postRsvaCancelScheduledRateCodeByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/rsva/${serviceName}/cancelScheduledRateCode`
    );
  };

  /** Current rate code related to this sva */
  getRsvaCurrentRateCodeByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyDetailedRateCodeInformation> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/rsva/${serviceName}/currentRateCode`
    );
  };

  /** Schedule a new rate code for this sva */
  postRsvaScheduleRateCodeByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { rateCode: string }
  ): Promise<TelephonyDetailedRateCodeInformation> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/rsva/${serviceName}/scheduleRateCode`,
      body
    );
  };

  /** New scheduled rate code related to this sva */
  getRsvaScheduledRateCodeByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyDetailedRateCodeInformation> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/rsva/${serviceName}/scheduledRateCode`
    );
  };

  /** Scheduled events */
  getSchedulerByBillingAccount = (billingAccount: string): Promise<string[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/scheduler`);
  };

  /** Get this object properties */
  getSchedulerByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyScheduler> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/scheduler/${serviceName}`);
  };

  /** Alter this object properties */
  updateSchedulerByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyScheduler
  ): Promise<void> => {
    return this.ovh.request('PUT', `/telephony/${billingAccount}/scheduler/${serviceName}`, body);
  };

  /** Custom events scheduled */
  getSchedulerEventsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/scheduler/${serviceName}/events`);
  };

  /** Add a scheduler event */
  addSchedulerEventsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: {
      category: TelephonySchedulerCategoryEnum;
      dateEnd: Date;
      dateStart: Date;
      description?: string;
      title: string;
      uid?: string;
    }
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/scheduler/${serviceName}/events`,
      body
    );
  };

  /** Delete the given scheduler event */
  deleteSchedulerEventsByBillingAccountAndServiceNameAndUid = (
    billingAccount: string,
    serviceName: string,
    uid: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/scheduler/${serviceName}/events/${uid}`
    );
  };

  /** Get this object properties */
  getSchedulerEventsByBillingAccountAndServiceNameAndUid = (
    billingAccount: string,
    serviceName: string,
    uid: string
  ): Promise<TelephonySchedulerEvent> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/scheduler/${serviceName}/events/${uid}`
    );
  };

  /** Alter this object properties */
  updateSchedulerEventsByBillingAccountAndServiceNameAndUid = (
    billingAccount: string,
    serviceName: string,
    uid: string,
    body: TelephonySchedulerEvent
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/scheduler/${serviceName}/events/${uid}`,
      body
    );
  };

  /** Add scheduler events in ICS format */
  addSchedulerImportIcsCalendarByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { url: string }
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/scheduler/${serviceName}/importIcsCalendar`,
      body
    );
  };

  /** Screenlist compatible numbers associated with this billing account */
  getScreenByBillingAccount = (billingAccount: string): Promise<string[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/screen`);
  };

  /** Get this object properties */
  getScreenByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyScreen> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/screen/${serviceName}`);
  };

  /** Alter this object properties */
  updateScreenByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyScreen
  ): Promise<void> => {
    return this.ovh.request('PUT', `/telephony/${billingAccount}/screen/${serviceName}`, body);
  };

  /** Rules for call filtering for this service */
  getScreenScreenListsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/screen/${serviceName}/screenLists`
    );
  };

  /** Create a new screen list rule */
  createScreenScreenListsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: {
      callNumber?: string;
      nature: TelephonyScreenListNatureEnum;
      type: TelephonyScreenListTypeEnum;
    }
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/screen/${serviceName}/screenLists`,
      body
    );
  };

  /** Delete the given screen list */
  deleteScreenScreenListsByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/screen/${serviceName}/screenLists/${id}`
    );
  };

  /** Get this object properties */
  getScreenScreenListsByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyScreenList> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/screen/${serviceName}/screenLists/${id}`
    );
  };

  /** Services associated with this billing account */
  getServiceByBillingAccount = (billingAccount: string): Promise<string[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/service`);
  };

  /** Ask for a service termination. */
  deleteServiceByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('DELETE', `/telephony/${billingAccount}/service/${serviceName}`);
  };

  /** Get this object properties */
  getServiceByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyTelephonyService> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/service/${serviceName}`);
  };

  /** Alter this object properties */
  updateServiceByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyTelephonyService
  ): Promise<void> => {
    return this.ovh.request('PUT', `/telephony/${billingAccount}/service/${serviceName}`, body);
  };

  /** Cancel the service termination */
  postServiceCancelTerminationByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/service/${serviceName}/cancelTermination`
    );
  };

  /** Move a service of billing account. Source and destination nics should be the same. */
  postServiceChangeOfBillingAccountByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { billingAccountDestination: string }
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/service/${serviceName}/changeOfBillingAccount`,
      body
    );
  };

  /** Get Relevant informations of the service detected from the MOS or the signal leg in SIP/MGCP protocol. */
  getServiceDiagnosticReportsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyDiagnosticReport[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/service/${serviceName}/diagnosticReports`
    );
  };

  /** Get this object properties */
  getServiceDirectoryByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyDirectoryInfo> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/service/${serviceName}/directory`);
  };

  /** Alter this object properties */
  updateServiceDirectoryByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyDirectoryInfo
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/service/${serviceName}/directory`,
      body
    );
  };

  /** Get company entreprise informations by providing entreprise number */
  postServiceDirectoryFetchEntrepriseInformationsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { entrepriseNumber: string }
  ): Promise<TelephonyEntrepriseNumberInformationsTask> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/service/${serviceName}/directory/fetchEntrepriseInformations`,
      body
    );
  };

  /** Get directory service code from an APE code ( principal activity of the firm code ) */
  getServiceDirectoryGetDirectoryServiceCodeByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyDirectoryHeadingPJ[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/service/${serviceName}/directory/getDirectoryServiceCode`
    );
  };

  /** Get all the way types availables */
  getServiceDirectoryGetWayTypesByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyDirectoryWayType[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/service/${serviceName}/directory/getWayTypes`
    );
  };

  /** Delete the given token */
  deleteServiceEventTokenByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/service/${serviceName}/eventToken`
    );
  };

  /** Get this object properties */
  getServiceEventTokenByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyEventToken> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/service/${serviceName}/eventToken`
    );
  };

  /** Create a new token */
  createServiceEventTokenByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { expiration: TelephonyTokenExpirationEnum }
  ): Promise<string> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/service/${serviceName}/eventToken`,
      body
    );
  };

  /** Fax delivery records. */
  getServiceFaxConsumptionByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/service/${serviceName}/faxConsumption`
    );
  };

  /** Get this object properties */
  getServiceFaxConsumptionByBillingAccountAndServiceNameAndConsumptionId = (
    billingAccount: string,
    consumptionId: number,
    serviceName: string
  ): Promise<TelephonyFaxConsumption> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/service/${serviceName}/faxConsumption/${consumptionId}`
    );
  };

  /** Delete the replacement offer scheduling */
  deleteServiceOfferChangeByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/service/${serviceName}/offerChange`
    );
  };

  /** Get this object properties */
  getServiceOfferChangeByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyOfferChange> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/service/${serviceName}/offerChange`
    );
  };

  /** Add a new offer change */
  addServiceOfferChangeByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { offer: string }
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/service/${serviceName}/offerChange`,
      body
    );
  };

  /** List all available offer changes compatibilities */
  listServiceOfferChangesByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyLineOffer[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/service/${serviceName}/offerChanges`
    );
  };

  /** Operations on a telephony service's offer */
  getServiceOfferTaskByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/service/${serviceName}/offerTask`);
  };

  /** Get this object properties */
  getServiceOfferTaskByBillingAccountAndServiceNameAndTaskId = (
    billingAccount: string,
    serviceName: string,
    taskId: number
  ): Promise<TelephonyOfferTask> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/service/${serviceName}/offerTask/${taskId}`
    );
  };

  /** Alter this object properties */
  updateServiceOfferTaskByBillingAccountAndServiceNameAndTaskId = (
    billingAccount: string,
    serviceName: string,
    taskId: number,
    body: TelephonyOfferTask
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/service/${serviceName}/offerTask/${taskId}`,
      body
    );
  };

  /** Call delivery records of the previous month. */
  getServicePreviousVoiceConsumptionByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/service/${serviceName}/previousVoiceConsumption`
    );
  };

  /** Get this object properties */
  getServicePreviousVoiceConsumptionByBillingAccountAndServiceNameAndConsumptionId = (
    billingAccount: string,
    consumptionId: number,
    serviceName: string
  ): Promise<TelephonyPreviousVoiceConsumption> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/service/${serviceName}/previousVoiceConsumption/${consumptionId}`
    );
  };

  /** Call which could be repayable */
  getServiceRepaymentConsumptionByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/service/${serviceName}/repaymentConsumption`
    );
  };

  /** Get this object properties */
  getServiceRepaymentConsumptionByBillingAccountAndServiceNameAndConsumptionId = (
    billingAccount: string,
    consumptionId: number,
    serviceName: string
  ): Promise<TelephonyRepaymentConsumption> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/service/${serviceName}/repaymentConsumption/${consumptionId}`
    );
  };

  /** Operations on a telephony service */
  getServiceTaskByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/service/${serviceName}/task`);
  };

  /** Get this object properties */
  getServiceTaskByBillingAccountAndServiceNameAndTaskId = (
    billingAccount: string,
    serviceName: string,
    taskId: number
  ): Promise<TelephonyTask> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/service/${serviceName}/task/${taskId}`
    );
  };

  /** Call delivery records. */
  getServiceVoiceConsumptionByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/service/${serviceName}/voiceConsumption`
    );
  };

  /** Get this object properties */
  getServiceVoiceConsumptionByBillingAccountAndServiceNameAndConsumptionId = (
    billingAccount: string,
    consumptionId: number,
    serviceName: string
  ): Promise<TelephonyVoiceConsumption> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/service/${serviceName}/voiceConsumption/${consumptionId}`
    );
  };

  /** Get this object properties */
  getServiceVoiceConsumptionCallDiagnosticsByBillingAccountAndServiceNameAndConsumptionId = (
    billingAccount: string,
    consumptionId: number,
    serviceName: string
  ): Promise<TelephonyCallDiagnostics> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/service/${serviceName}/voiceConsumption/${consumptionId}/callDiagnostics`
    );
  };

  /** Get this object properties */
  getServiceInfosByBillingAccount = (billingAccount: string): Promise<ServicesService> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/serviceInfos`);
  };

  /** Alter this object properties */
  updateServiceInfosByBillingAccount = (
    billingAccount: string,
    body: ServicesService
  ): Promise<void> => {
    return this.ovh.request('PUT', `/telephony/${billingAccount}/serviceInfos`, body);
  };

  /** Operations on a telephony billing account */
  getTaskByBillingAccount = (billingAccount: string): Promise<number[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/task`);
  };

  /** Get this object properties */
  getTaskByBillingAccountAndTaskId = (
    billingAccount: string,
    taskId: number
  ): Promise<TelephonyTask> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/task/${taskId}`);
  };

  /** Time conditions compatible numbers associated with this billing account */
  getTimeConditionByBillingAccount = (billingAccount: string): Promise<string[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/timeCondition`);
  };

  /** Get this object properties */
  getTimeConditionByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyGenericScreen> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/timeCondition/${serviceName}`);
  };

  /** Rules for time conditions for this service */
  getTimeConditionConditionByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/timeCondition/${serviceName}/condition`
    );
  };

  /** Create a new time condition rule */
  createTimeConditionConditionByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: {
      day: TelephonyTimeConditionsDayEnum;
      hourBegin: string;
      hourEnd: string;
      policy: TelephonyTimeConditionsPolicyEnum;
    }
  ): Promise<TelephonyTimeCondition> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/timeCondition/${serviceName}/condition`,
      body
    );
  };

  /** Delete the given screen list */
  deleteTimeConditionConditionByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/timeCondition/${serviceName}/condition/${id}`
    );
  };

  /** Get this object properties */
  getTimeConditionConditionByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyTimeCondition> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/timeCondition/${serviceName}/condition/${id}`
    );
  };

  /** Alter this object properties */
  updateTimeConditionConditionByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string,
    body: TelephonyTimeCondition
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/timeCondition/${serviceName}/condition/${id}`,
      body
    );
  };

  /** Get this object properties */
  getTimeConditionOptionsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyTimeConditionOptions> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/timeCondition/${serviceName}/options`
    );
  };

  /** Alter this object properties */
  updateTimeConditionOptionsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyTimeConditionOptions
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/timeCondition/${serviceName}/options`,
      body
    );
  };

  /** Transfer security deposit between two billing accounts */
  postTransferSecurityDepositByBillingAccount = (
    billingAccount: string,
    body: { amount: number; billingAccountDestination: string }
  ): Promise<void> => {
    return this.ovh.request('POST', `/telephony/${billingAccount}/transferSecurityDeposit`, body);
  };

  /** Trunk associated with this billing account */
  getTrunkByBillingAccount = (billingAccount: string): Promise<string[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/trunk`);
  };

  /** Get this object properties */
  getTrunkByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyTrunk> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/trunk/${serviceName}`);
  };

  /** Determine the best channels packs combination for a given channel quantity */
  getTrunkChannelsPacksRepartitionByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyTrunkSimultaneousPacksRepartition> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/trunk/${serviceName}/channelsPacksRepartition`
    );
  };

  /** External displayed number linked to this trunk */
  getTrunkExternalDisplayedNumberByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/trunk/${serviceName}/externalDisplayedNumber`
    );
  };

  /** External displayed number creation for a given trunk */
  postTrunkExternalDisplayedNumberByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { autoValidation?: boolean; number: string }
  ): Promise<TelephonyTrunkExternalDisplayedNumber> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/trunk/${serviceName}/externalDisplayedNumber`,
      body
    );
  };

  /** Delete an external displayed number for a given trunk */
  deleteTrunkExternalDisplayedNumberByBillingAccountAndServiceNameAndNumber = (
    billingAccount: string,
    number: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/trunk/${serviceName}/externalDisplayedNumber/${number}`
    );
  };

  /** Get this object properties */
  getTrunkExternalDisplayedNumberByBillingAccountAndServiceNameAndNumber = (
    billingAccount: string,
    number: string,
    serviceName: string
  ): Promise<TelephonyTrunkExternalDisplayedNumber> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/trunk/${serviceName}/externalDisplayedNumber/${number}`
    );
  };

  /** Generate a phone call for validation. Returned validation code should be typed when asked. */
  postTrunkExternalDisplayedNumberValidateByBillingAccountAndServiceNameAndNumber = (
    billingAccount: string,
    number: string,
    serviceName: string
  ): Promise<TelephonyTrunkExternalDisplayedNumberValidation> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/trunk/${serviceName}/externalDisplayedNumber/${number}/validate`
    );
  };

  /** Voicemails associated with this billing account */
  getVoicemailByBillingAccount = (billingAccount: string): Promise<string[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/voicemail`);
  };

  /** Get this object properties */
  getVoicemailByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyVoicemail> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/voicemail/${serviceName}`);
  };

  /** Alter this object properties */
  updateVoicemailByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyVoicemail
  ): Promise<void> => {
    return this.ovh.request('PUT', `/telephony/${billingAccount}/voicemail/${serviceName}`, body);
  };

  /** Voicemail directory messages */
  getVoicemailDirectoriesByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/voicemail/${serviceName}/directories`
    );
  };

  /** Delete the given voicemail message */
  deleteVoicemailDirectoriesByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/voicemail/${serviceName}/directories/${id}`
    );
  };

  /** Get this object properties */
  getVoicemailDirectoriesByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyVoicemailMessages> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/voicemail/${serviceName}/directories/${id}`
    );
  };

  /** Get a url to download the sound file */
  getVoicemailDirectoriesDownloadByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyPcsFile> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/voicemail/${serviceName}/directories/${id}/download`
    );
  };

  /** Move the message to another directory */
  postVoicemailDirectoriesMoveByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string,
    body: { dir: TelephonyVoicemailMessageFolderDirectoryEnum }
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/voicemail/${serviceName}/directories/${id}/move`,
      body
    );
  };

  /** Voicemail greeting message properties */
  getVoicemailGreetingsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/voicemail/${serviceName}/greetings`
    );
  };

  /** Upload a new sound for a specific greeting. Return a task id. */
  postVoicemailGreetingsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { dir: TelephonyVoicemailMessageFolderGreetingEnum; documentId: string }
  ): Promise<number> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/voicemail/${serviceName}/greetings`,
      body
    );
  };

  /** Delete the customized greeting */
  deleteVoicemailGreetingsByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/telephony/${billingAccount}/voicemail/${serviceName}/greetings/${id}`
    );
  };

  /** Get this object properties */
  getVoicemailGreetingsByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyVoicemailGreetings> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/voicemail/${serviceName}/greetings/${id}`
    );
  };

  /** Get a url to download the sound file */
  getVoicemailGreetingsDownloadByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string
  ): Promise<TelephonyPcsFile> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/voicemail/${serviceName}/greetings/${id}/download`
    );
  };

  /** Move the message to another directory */
  postVoicemailGreetingsMoveByBillingAccountAndServiceNameAndId = (
    billingAccount: string,
    id: number,
    serviceName: string,
    body: { dir: TelephonyVoicemailMessageFolderGreetingEnum }
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/voicemail/${serviceName}/greetings/${id}/move`,
      body
    );
  };

  /** Change the voicemail on a new version to manager greetings, directories and extra settings. */
  updateVoicemailMigrateOnNewVersionByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/voicemail/${serviceName}/migrateOnNewVersion`
    );
  };

  /** Get this object properties */
  getVoicemailSettingsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyVoicemailProperties> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/voicemail/${serviceName}/settings`
    );
  };

  /** Alter this object properties */
  updateVoicemailSettingsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyVoicemailProperties
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/voicemail/${serviceName}/settings`,
      body
    );
  };

  /** Change the voicemail password. It must be 4 digit */
  updateVoicemailSettingsPasswordByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { password: string }
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/voicemail/${serviceName}/settings/changePassword`,
      body
    );
  };

  /** Disable/Enable voicemail. Available only if the line has fax capabilities */
  disableVoicemailSettingsChangeRoutingByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: { routing: TelephonyVoicefaxRoutingEnum }
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/voicemail/${serviceName}/settings/changeRouting`,
      body
    );
  };

  /** Get the status of the voicemail. Available only if the line has fax capabilities */
  getVoicemailSettingsRoutingByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyVoicefaxRoutingEnum> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/voicemail/${serviceName}/settings/routing`
    );
  };

  /** Get number for internal and external voicemail */
  getVoicemailSettingsVoicemailNumbersByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyVoicemailNumbers> => {
    return this.ovh.request(
      'GET',
      `/telephony/${billingAccount}/voicemail/${serviceName}/settings/voicemailNumbers`
    );
  };

  /** Vxml numbers associated with this billing account */
  getVxmlByBillingAccount = (billingAccount: string): Promise<string[]> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/vxml`);
  };

  /** Get this object properties */
  getVxmlByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyVxml> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/vxml/${serviceName}`);
  };

  /** Get this object properties */
  getVxmlSettingsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyVxmlProperties> => {
    return this.ovh.request('GET', `/telephony/${billingAccount}/vxml/${serviceName}/settings`);
  };

  /** Alter this object properties */
  updateVxmlSettingsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string,
    body: TelephonyVxmlProperties
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/telephony/${billingAccount}/vxml/${serviceName}/settings`,
      body
    );
  };

  /** Generate a temporary url to retrieve device logs */
  postVxmlSettingsLogsByBillingAccountAndServiceName = (
    billingAccount: string,
    serviceName: string
  ): Promise<TelephonyTemporaryLogsLink> => {
    return this.ovh.request(
      'POST',
      `/telephony/${billingAccount}/vxml/${serviceName}/settings/logs`
    );
  };
}

export { TelephonyHandler };
